import {
  FormControlLabel,
  Grid,
  Link,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import AutoComplete from "../../components/Comman/AutoComplete";
import { ButtonCompo } from "../../components/Comman/Button";
import BasicDatePicker from "../../components/Comman/DatePickerEx";
import { LabelCompo } from "../../components/Comman/Label";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import RTTable from "../../components/Comman/RT/RTTable";
import { cyanBlue, redColor, titleColor } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import {
  dataNotFoundMsg,
  noInternetMsg,
  serverMsg,
} from "../../config/messageconstant";
import { getSelectedBeatCountFromSalesTeamIdAndDate } from "../../Slice/beat.slice";
import {
  getBelowSalesTeamByReportingId,
  getSalesTeamUserSummary,
  getSalesTeamUserSummaryTeamWise,
  getSalesTeamWorkingSummary,
  getUnderSalesTeamWorkingSummary,
  getTopOrderSalesTeam,
  setSalesTeamWorkingSummary,
  setSalesTeamUserSummaryTeamWise,
} from "../../Slice/manager.slice";
import { getSalesExecutive, getBelowSalesTeamList } from "../../Slice/salesExecutive.slice";
import { getStockStakeHolderType } from "../../Slice/stockStakeHolderType.slice";
import BeatPopUp from "../DashbourdChanges/BeatPopUp";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadF } from "../PDF/PDFDownload";
import { getSubCategoryWiseReportBySalesTeam } from "../../Slice/salesTeamCategoryWiseData.slice";
import SubCategoryWiseForUserSummary from "./SubCategoryWiseForUserSummary";

class UserSummaryNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {
        nationalSalesManagerDetail: this.props.managerList?.allNSM,
        salesOfficerDetail: this.props.managerList?.salesTeamBelowReportingIdSO,
      },

      userType3SortOrderNo1Value: "",
      userType3SortOrderNo2Value: "",
      userType3SortOrderNo3Value: "",
      userType3SortOrderNo4Value: "",
      userType3SortOrderNo5Value: "",
      userType3SortOrderNo6Value: "",
      userType3SortOrderNo7Value: "",
      userType3SortOrderNo8Value: "",
      userType4SortOrderNo1Value: "",

      userType3SortOrderNo1Flag: {},
      userType3SortOrderNo2Flag: {},
      userType3SortOrderNo3Flag: {},
      userType3SortOrderNo4Flag: {},
      userType3SortOrderNo5Flag: {},
      userType3SortOrderNo6Flag: {},
      userType3SortOrderNo7Flag: {},
      userType3SortOrderNo8Flag: {},
      userType4SortOrderNo1Flag: {},

      userType3SortOrderNo1List: [],
      userType3SortOrderNo2List: [],
      userType3SortOrderNo3List: [],
      userType3SortOrderNo4List: [],
      userType3SortOrderNo5List: [],
      userType3SortOrderNo6List: [],
      userType3SortOrderNo7List: [],
      userType3SortOrderNo8List: [],
      userType4SortOrderNo1List: [],

      fromDate: "",
      toDate: "",
      formErrors: {},
      stockHolderTypeId: "",
      rowList: [],
      beatPopUpFlag: false,
      summaryTableFlag: false,
      teamWiseAnalysis: false,
      underSalesTeamSummaryFlag: false,
      salesTeamList: [],
      nsmList: [],
      rsmList: [],
      zsmList: [],
      asmList: [],
      aseList: [],
      soList: [],
      tsiList: [],
      nsmId: "",
      zsmId: "",
      rsmId: "",
      asmId: "",
      aseId: "",
      soId: "",
      tsiId: "",
      fromDate: dayjs(),
      toDate: dayjs(),
      value: 0,
      radioType: 0,
      flag: 0,
      stockHolderType: "",
      salesTeam: "",
      dateFlag: "",
      salesTeamIdForExcel: "",
      userTypeId: "",
      sortOrderNo: "",
      dataResponseForSubCat: {},
      catsubCatMatrixData: [],
      matrixDataListForSubCat: [],
      searchValue: "",
    };
  }

  async componentDidMount() {
    const {
      getTopOrderSalesTeam,
      getStockStakeHolderType,
      showLoador,
      showNotification,
      setSalesTeamWorkingSummary,
      getBelowSalesTeamList,
    } = this.props;

    const isShowCategoryWiseAnalysis = localStorage.getItem(
      "isShowCategoryWiseAnalysis"
    );

    const isUserType = localStorage.getItem("userTypeId");

    this.setState({
      isShowCategoryWiseAnalysis: isShowCategoryWiseAnalysis,
      radioType: isUserType == 3 ? 2 : 0
    });


    if (isUserType == 3) {
      showLoador({ loador: true });
      await getBelowSalesTeamList({ salesTeamId: "", flag: "1" }).then(
        ({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        }
      );
    } else {
      showLoador({ loador: true });
      await getStockStakeHolderType({ userTypeIds: "3,4" }).then(
        ({ response, success }) => {
          if (!success) {
            showLoador({ loador: false });
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            getTopOrderSalesTeam().then(({ response, success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              } else {
                this.setState({
                  userType3SortOrderNo1Flag:
                    response.length != 0 ? response[0] : {},
                  userType3SortOrderNo1List: response,
                });
              }
            });
          }
        }
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.managerList !== nextProps.managerList) {
      if (this.props.managerList?.allNSM !== nextProps.managerList?.allNSM) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            nationalSalesManagerDetail: nextProps.managerList?.allNSM,
          },
        });
      }
    }
  }

  getListById = (userTypeAndSortOrderList, newValue) => {
    const { getBelowSalesTeamByReportingId, showLoador, showNotification } =
      this.props;

    showLoador({ loador: true });
    getBelowSalesTeamByReportingId({
      stockStakeHolderTypeId: userTypeAndSortOrderList.id,
      salesTeamId: newValue,
    }).then(({ response, success }) => {
      showLoador({ loador: false });
      if (!success) {
        showNotification({ msg: serverMsg, severity: "error" });
      } else {
        let userType3SortOrderNo2ListNew = response.data.filter(
          (row) => row.userTypeId == 3 && row.sortOrder == 2
        );
        let userType3SortOrderNo3ListNew = response.data.filter(
          (row) => row.userTypeId == 3 && row.sortOrder == 3
        );
        let userType3SortOrderNo4ListNew = response.data.filter(
          (row) => row.userTypeId == 3 && row.sortOrder == 4
        );
        let userType3SortOrderNo5ListNew = response.data.filter(
          (row) => row.userTypeId == 3 && row.sortOrder == 5
        );
        let userType3SortOrderNo6ListNew = response.data.filter(
          (row) => row.userTypeId == 3 && row.sortOrder == 6
        );
        let userType3SortOrderNo7ListNew = response.data.filter(
          (row) => row.userTypeId == 3 && row.sortOrder == 7
        );
        let userType3SortOrderNo8ListNew = response.data.filter(
          (row) => row.userTypeId == 3 && row.sortOrder == 8
        );
        let userType4SortOrderNo1ListNew = response.data.filter(
          (row) => row.userTypeId == 4 && row.sortOrder == 1
        );
        console.log(userType3SortOrderNo2ListNew);
        if (userTypeAndSortOrderList.sortOrder == 1) {
          this.setState({
            userType3SortOrderNo2List:
              userType3SortOrderNo2ListNew.length != 0
                ? userType3SortOrderNo2ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo3List:
              userType3SortOrderNo3ListNew.length != 0
                ? userType3SortOrderNo3ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo4List:
              userType3SortOrderNo4ListNew.length != 0
                ? userType3SortOrderNo4ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo5List:
              userType3SortOrderNo5ListNew.length != 0
                ? userType3SortOrderNo5ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo6List:
              userType3SortOrderNo6ListNew.length != 0
                ? userType3SortOrderNo6ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo7List:
              userType3SortOrderNo7ListNew.length != 0
                ? userType3SortOrderNo7ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo8List:
              userType3SortOrderNo8ListNew.length != 0
                ? userType3SortOrderNo8ListNew[0].salesTeamList
                : "",
            userType4SortOrderNo1List:
              userType4SortOrderNo1ListNew.length != 0
                ? userType4SortOrderNo1ListNew[0].salesTeamList
                : "",
          });
        } else if (userTypeAndSortOrderList.sortOrder == 2) {
          this.setState({
            userType3SortOrderNo3List:
              userType3SortOrderNo3ListNew.length != 0
                ? userType3SortOrderNo3ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo4List:
              userType3SortOrderNo4ListNew.length != 0
                ? userType3SortOrderNo4ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo5List:
              userType3SortOrderNo5ListNew.length != 0
                ? userType3SortOrderNo5ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo6List:
              userType3SortOrderNo6ListNew.length != 0
                ? userType3SortOrderNo6ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo7List:
              userType3SortOrderNo7ListNew.length != 0
                ? userType3SortOrderNo7ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo8List:
              userType3SortOrderNo8ListNew.length != 0
                ? userType3SortOrderNo8ListNew[0].salesTeamList
                : "",
            userType4SortOrderNo1List:
              userType4SortOrderNo1ListNew.length != 0
                ? userType4SortOrderNo1ListNew[0].salesTeamList
                : "",
          });
        } else if (userTypeAndSortOrderList.sortOrder == 3) {
          this.setState({
            userType3SortOrderNo4List:
              userType3SortOrderNo4ListNew.length != 0
                ? userType3SortOrderNo4ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo5List:
              userType3SortOrderNo5ListNew.length != 0
                ? userType3SortOrderNo5ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo6List:
              userType3SortOrderNo6ListNew.length != 0
                ? userType3SortOrderNo6ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo7List:
              userType3SortOrderNo7ListNew.length != 0
                ? userType3SortOrderNo7ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo8List:
              userType3SortOrderNo8ListNew.length != 0
                ? userType3SortOrderNo8ListNew[0].salesTeamList
                : "",
            userType4SortOrderNo1List:
              userType4SortOrderNo1ListNew.length != 0
                ? userType4SortOrderNo1ListNew[0].salesTeamList
                : "",
          });
        } else if (userTypeAndSortOrderList.sortOrder == 4) {
          this.setState({
            userType3SortOrderNo5List:
              userType3SortOrderNo5ListNew.length != 0
                ? userType3SortOrderNo5ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo6List:
              userType3SortOrderNo6ListNew.length != 0
                ? userType3SortOrderNo6ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo7List:
              userType3SortOrderNo7ListNew.length != 0
                ? userType3SortOrderNo7ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo8List:
              userType3SortOrderNo8ListNew.length != 0
                ? userType3SortOrderNo8ListNew[0].salesTeamList
                : "",
            userType4SortOrderNo1List:
              userType4SortOrderNo1ListNew.length != 0
                ? userType4SortOrderNo1ListNew[0].salesTeamList
                : "",
          });
        } else if (userTypeAndSortOrderList.sortOrder == 5) {
          this.setState({
            userType3SortOrderNo6List:
              userType3SortOrderNo6ListNew.length != 0
                ? userType3SortOrderNo6ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo7List:
              userType3SortOrderNo7ListNew.length != 0
                ? userType3SortOrderNo7ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo8List:
              userType3SortOrderNo8ListNew.length != 0
                ? userType3SortOrderNo8ListNew[0].salesTeamList
                : "",
            userType4SortOrderNo1List:
              userType4SortOrderNo1ListNew.length != 0
                ? userType4SortOrderNo1ListNew[0].salesTeamList
                : "",
          });
        } else if (userTypeAndSortOrderList.sortOrder == 6) {
          this.setState({
            userType3SortOrderNo7List:
              userType3SortOrderNo7ListNew.length != 0
                ? userType3SortOrderNo7ListNew[0].salesTeamList
                : "",
            userType3SortOrderNo8List:
              userType3SortOrderNo8ListNew.length != 0
                ? userType3SortOrderNo8ListNew[0].salesTeamList
                : "",
            userType4SortOrderNo1List:
              userType4SortOrderNo1ListNew.length != 0
                ? userType4SortOrderNo1ListNew[0].salesTeamList
                : "",
          });
        } else if (userTypeAndSortOrderList.sortOrder == 7) {
          this.setState({
            userType3SortOrderNo8List:
              userType3SortOrderNo8ListNew.length != 0
                ? userType3SortOrderNo8ListNew[0].salesTeamList
                : "",
            userType4SortOrderNo1List:
              userType4SortOrderNo1ListNew.length != 0
                ? userType4SortOrderNo1ListNew[0].salesTeamList
                : "",
          });
        } else if (userTypeAndSortOrderList.sortOrder == 8) {
          this.setState({
            userType4SortOrderNo1List:
              userType4SortOrderNo1ListNew.length != 0
                ? userType4SortOrderNo1ListNew[0].salesTeamList
                : "",
          });
        }

        this.setState({
          userType3SortOrderNo2Flag:
            userType3SortOrderNo2ListNew.length != 0
              ? userType3SortOrderNo2ListNew[0]
              : {},
          userType3SortOrderNo3Flag:
            userType3SortOrderNo3ListNew.length != 0
              ? userType3SortOrderNo3ListNew[0]
              : {},
          userType3SortOrderNo4Flag:
            userType3SortOrderNo4ListNew.length != 0
              ? userType3SortOrderNo4ListNew[0]
              : {},
          userType3SortOrderNo5Flag:
            userType3SortOrderNo5ListNew.length != 0
              ? userType3SortOrderNo5ListNew[0]
              : {},
          userType3SortOrderNo6Flag:
            userType3SortOrderNo6ListNew.length != 0
              ? userType3SortOrderNo6ListNew[0]
              : {},
          userType3SortOrderNo7Flag:
            userType3SortOrderNo7ListNew.length != 0
              ? userType3SortOrderNo7ListNew[0]
              : {},
          userType3SortOrderNo8Flag:
            userType3SortOrderNo8ListNew.length != 0
              ? userType3SortOrderNo8ListNew[0]
              : {},
          userType4SortOrderNo1Flag:
            userType4SortOrderNo1ListNew.length != 0
              ? userType4SortOrderNo1ListNew[0]
              : {},
        });
      }
    });
  };

  onSearchHandler = (userTypeId, sortOrderNo) => {
    const {
      getSalesTeamUserSummary,
      stockStakeHolderTypeList,
      showLoador,
      showNotification,
    } = this.props;
    const {
      fromDate,
      toDate,
      userType3SortOrderNo1Value,
      userType3SortOrderNo2Value,
      userType3SortOrderNo3Value,
      userType3SortOrderNo4Value,
      userType3SortOrderNo5Value,
      userType3SortOrderNo6Value,
      userType3SortOrderNo7Value,
      userType3SortOrderNo8Value,
      userType4SortOrderNo1Value,
    } = this.state;

    const diffDays = dayjs(toDate).diff(dayjs(fromDate), "day") + 2;

    this.setState({ summaryTableFlag: false, teamWiseAnalysis: false });

    let stockStakeHolderList =
      stockStakeHolderTypeList?.stockStakeHolderType.filter(
        (row) => row.userType.id == userTypeId && row.sortOrder == sortOrderNo
      );

    let value =
      userTypeId == 3 && sortOrderNo == 1
        ? userType3SortOrderNo1Value
        : userTypeId == 3 && sortOrderNo == 2
          ? userType3SortOrderNo2Value
          : userTypeId == 3 && sortOrderNo == 3
            ? userType3SortOrderNo3Value
            : userTypeId == 3 && sortOrderNo == 4
              ? userType3SortOrderNo4Value
              : userTypeId == 3 && sortOrderNo == 5
                ? userType3SortOrderNo5Value
                : userTypeId == 3 && sortOrderNo == 6
                  ? userType3SortOrderNo6Value
                  : userTypeId == 3 && sortOrderNo == 7
                    ? userType3SortOrderNo7Value
                    : userTypeId == 3 && sortOrderNo == 8
                      ? userType3SortOrderNo8Value
                      : userTypeId == 4 && sortOrderNo == 1
                        ? userType4SortOrderNo1Value
                        : "";

    this.setState({
      salesTeamIdForExcel: value,
      userTypeId: userTypeId,
      sortOrderNo: sortOrderNo,
    });

    if (navigator.onLine) {
      if (this.checkValidation(userTypeId, sortOrderNo)) {
        if (diffDays > 7) {
          this.generateExcelUserSummaryEmployeeWise(value, false);
          return;
        } else {
          let responseList = [];
          showLoador({ loador: true });
          getSalesTeamUserSummary({
            stockStakeHolderTypeId:
              stockStakeHolderList.length != 0
                ? stockStakeHolderList[0].id
                : "",
            salesTeamId: value,
            userTypeId: userTypeId,
            fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
            toDate: dayjs(toDate).format("DD-MM-YYYY"),
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              if (Object.keys(response).length !== 0) {
                this.setState({ dateFlag: response.flag });
                responseList.push(response);
              }
              this.setState({
                rowList: responseList,
                fromDate: fromDate,
                toDate: toDate,
              });
            }
          });
        }
      }
    }
  };

  onSearchHandlerForSalesTeam = (userTypeId, sortOrderNo) => {
    const {
      getSalesTeamUserSummaryTeamWise,
      stockStakeHolderTypeList,
      showLoador,
      showNotification,
    } = this.props;
    const {
      fromDate,
      toDate,
      userType3SortOrderNo1Value,
      userType3SortOrderNo2Value,
      userType3SortOrderNo3Value,
      userType3SortOrderNo4Value,
      userType3SortOrderNo5Value,
      userType3SortOrderNo6Value,
      userType3SortOrderNo7Value,
      userType3SortOrderNo8Value,
      userType4SortOrderNo1Value,
    } = this.state;

    const diffDays = dayjs(toDate).diff(dayjs(fromDate), "day") + 2;

    this.setState({ summaryTableFlag: false });

    let stockStakeHolderList =
      stockStakeHolderTypeList?.stockStakeHolderType.filter(
        (row) => row.userType.id == userTypeId && row.sortOrder == sortOrderNo
      );

    let value =
      userTypeId == 3 && sortOrderNo == 1
        ? userType3SortOrderNo1Value
        : userTypeId == 3 && sortOrderNo == 2
          ? userType3SortOrderNo2Value
          : userTypeId == 3 && sortOrderNo == 3
            ? userType3SortOrderNo3Value
            : userTypeId == 3 && sortOrderNo == 4
              ? userType3SortOrderNo4Value
              : userTypeId == 3 && sortOrderNo == 5
                ? userType3SortOrderNo5Value
                : userTypeId == 3 && sortOrderNo == 6
                  ? userType3SortOrderNo6Value
                  : userTypeId == 3 && sortOrderNo == 7
                    ? userType3SortOrderNo7Value
                    : userTypeId == 3 && sortOrderNo == 8
                      ? userType3SortOrderNo8Value
                      : userTypeId == 4 && sortOrderNo == 1
                        ? userType4SortOrderNo1Value
                        : "";

    this.setState({
      salesTeamIdForExcel: value,
      userTypeId: userTypeId,
      sortOrderNo: sortOrderNo,
      teamWiseAnalysis: true,
    });

    if (navigator.onLine) {
      if (this.checkValidation(userTypeId, sortOrderNo)) {
        if (diffDays > 7) {
          this.generateExcelUserSummaryEmployeeWise(value, true);
          return;
        } else {
          showLoador({ loador: true });
          getSalesTeamUserSummaryTeamWise({
            salesTeamId: value,
            userTypeId: userTypeId,
            fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
            toDate: dayjs(toDate).format("DD-MM-YYYY"),
            flag: 1,
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              if (response.length !== 0) {
                this.setState({
                  dateFlag: response[0].flag,
                  rowList: response,
                  fromDate: fromDate,
                  toDate: toDate,
                });
              }
            }
          });
        }
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearchHandlerForTeamWiseSummary = (userTypeId, sortOrderNo) => {
    const {
      getUnderSalesTeamWorkingSummary,
      stockStakeHolderTypeList,
      showLoador,
      showNotification,
    } = this.props;
    const {
      fromDate,
      toDate,
      userType3SortOrderNo1Value,
      userType3SortOrderNo2Value,
      userType3SortOrderNo3Value,
      userType3SortOrderNo4Value,
      userType3SortOrderNo5Value,
      userType3SortOrderNo6Value,
      userType3SortOrderNo7Value,
      userType3SortOrderNo8Value,
      userType4SortOrderNo1Value,
    } = this.state;

    const diffDays = dayjs(toDate).diff(dayjs(fromDate), "day") + 2;

    let value =
      userTypeId == 3 && sortOrderNo == 1
        ? userType3SortOrderNo1Value
        : userTypeId == 3 && sortOrderNo == 2
          ? userType3SortOrderNo2Value
          : userTypeId == 3 && sortOrderNo == 3
            ? userType3SortOrderNo3Value
            : userTypeId == 3 && sortOrderNo == 4
              ? userType3SortOrderNo4Value
              : userTypeId == 3 && sortOrderNo == 5
                ? userType3SortOrderNo5Value
                : userTypeId == 3 && sortOrderNo == 6
                  ? userType3SortOrderNo6Value
                  : userTypeId == 3 && sortOrderNo == 7
                    ? userType3SortOrderNo7Value
                    : userTypeId == 3 && sortOrderNo == 8
                      ? userType3SortOrderNo8Value
                      : userTypeId == 4 && sortOrderNo == 1
                        ? userType4SortOrderNo1Value
                        : "";

    this.setState({
      salesTeamIdForExcel: value,
      userTypeId: userTypeId,
      sortOrderNo: sortOrderNo,
      summaryTableFlag: true,
      teamWiseAnalysis: false,
      underSalesTeamSummaryFlag: true,
    });

    if (navigator.onLine) {
      if (this.checkValidation(userTypeId, sortOrderNo)) {
        if (diffDays > 7) {
          this.generateExcelForUserWorkSummaryEmployeeWise(value, true);
          return;
        } else {
          showLoador({ loador: true });
          getUnderSalesTeamWorkingSummary({
            salesTeamId: value,
            fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
            toDate: dayjs(toDate).format("DD-MM-YYYY"),
            flag: 1,
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              if (response.length !== 0) {
                this.setState({
                  dateFlag: response[0].flag,
                  rowList: response,
                  fromDate: fromDate,
                  toDate: toDate,
                });
              }
            }
          });
        }
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearchHandlerTypeWise = () => {
    const { getSalesTeamUserSummary, showLoador, showNotification } =
      this.props;
    const { fromDate, toDate, stockHolderType, salesTeam } = this.state;

    const diffDays = dayjs(toDate).diff(dayjs(fromDate), "day") + 2;

    if (navigator.onLine) {
      this.setState({
        summaryTableFlag: false,
        dataResponseForSubCat: {},
        teamWiseAnalysis: false,
      });

      if (this.checkValidationTypeWise()) {
        if (diffDays > 7) {
          this.setState({ rowList: [] });
          this.generateExcelForUserSummaryTypeWise(salesTeam, false);
          return;
        } else {
          let responseList = [];
          showLoador({ loador: true });
          getSalesTeamUserSummary({
            stockStakeHolderTypeId: stockHolderType,
            salesTeamId: salesTeam,
            fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
            toDate: dayjs(toDate).format("DD-MM-YYYY"),
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              if (Object.keys(response).length !== 0) {
                this.setState({ dateFlag: response.flag });
                responseList.push(response);
              }
              this.setState({
                rowList: responseList,
                fromDate: fromDate,
                toDate: toDate,
              });
            }
          });
        }
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearchHandlerTypeWiseForSalesTeam = () => {
    const { getSalesTeamUserSummaryTeamWise, showLoador, showNotification } =
      this.props;
    const { fromDate, toDate, salesTeam } = this.state;

    const diffDays = dayjs(toDate).diff(dayjs(fromDate), "day") + 2;

    if (navigator.onLine) {
      this.setState({
        summaryTableFlag: false,
        dataResponseForSubCat: {},
        teamWiseAnalysis: true,
      });

      if (this.checkValidationTypeWise()) {
        if (diffDays > 7) {
          this.setState({ rowList: [] });
          this.generateExcelForUserSummaryTypeWise(salesTeam, true);
          return;
        } else {
          let responseList = [];
          showLoador({ loador: true });
          getSalesTeamUserSummaryTeamWise({
            salesTeamId: salesTeam,
            fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
            toDate: dayjs(toDate).format("DD-MM-YYYY"),
            flag: 1,
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              if (response.length !== 0) {
                this.setState({
                  dateFlag: response[0].flag,
                  rowList: response,
                  fromDate: fromDate,
                  toDate: toDate,
                });
              }
            }
          });
        }
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSummaryHandler = (userTypeId, sortOrderNo) => {
    const { getSalesTeamWorkingSummary, showLoador, showNotification } =
      this.props;
    const {
      fromDate,
      toDate,
      userType3SortOrderNo1Value,
      userType3SortOrderNo2Value,
      userType3SortOrderNo3Value,
      userType3SortOrderNo4Value,
      userType3SortOrderNo5Value,
      userType3SortOrderNo6Value,
      userType3SortOrderNo7Value,
      userType3SortOrderNo8Value,
      userType4SortOrderNo1Value,
    } = this.state;

    const diffDays = dayjs(toDate).diff(dayjs(fromDate), "day") + 2;

    let value =
      userTypeId == 3 && sortOrderNo == 1
        ? userType3SortOrderNo1Value
        : userTypeId == 3 && sortOrderNo == 2
          ? userType3SortOrderNo2Value
          : userTypeId == 3 && sortOrderNo == 3
            ? userType3SortOrderNo3Value
            : userTypeId == 3 && sortOrderNo == 4
              ? userType3SortOrderNo4Value
              : userTypeId == 3 && sortOrderNo == 5
                ? userType3SortOrderNo5Value
                : userTypeId == 3 && sortOrderNo == 6
                  ? userType3SortOrderNo6Value
                  : userTypeId == 3 && sortOrderNo == 7
                    ? userType3SortOrderNo7Value
                    : userTypeId == 3 && sortOrderNo == 8
                      ? userType3SortOrderNo8Value
                      : userTypeId == 4 && sortOrderNo == 1
                        ? userType4SortOrderNo1Value
                        : "";

    this.setState({
      salesTeamIdForExcel: value,
      userTypeId: userTypeId,
      sortOrderNo: sortOrderNo,
      summaryTableFlag: true,
      teamWiseAnalysis: false,
      underSalesTeamSummaryFlag: false,
    });

    if (navigator.onLine) {
      if (this.checkValidation(userTypeId, sortOrderNo)) {
        if (diffDays > 7) {
          this.generateExcelForUserWorkSummaryEmployeeWise(value, false);
          return;
        } else {
          let jsonToSend = {
            salesTeamIds: value.split(","),
            fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
            toDate: dayjs(toDate).format("DD-MM-YYYY"),
          };

          showLoador({ loador: true });
          getSalesTeamWorkingSummary({ dataJson: jsonToSend }).then(
            ({ response, success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              } else {
                if (response.length === 0) {
                  showNotification({ msg: dataNotFoundMsg, severity: "error" });
                }
              }
            }
          );
        }
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onCategoryHandler = (userTypeId, sortOrderNo) => {
    const {
      getSubCategoryWiseReportBySalesTeam,
      showLoador,
      showNotification,
    } = this.props;
    const {
      fromDate,
      toDate,
      userType3SortOrderNo1Value,
      userType3SortOrderNo2Value,
      userType3SortOrderNo3Value,
      userType3SortOrderNo4Value,
      userType3SortOrderNo5Value,
      userType3SortOrderNo6Value,
      userType3SortOrderNo7Value,
      userType3SortOrderNo8Value,
      userType4SortOrderNo1Value,
      salesTeam,
    } = this.state;

    const diffDays = dayjs(toDate).diff(dayjs(fromDate), "day") + 2;

    let value =
      userTypeId == 3 && sortOrderNo == 1
        ? userType3SortOrderNo1Value
        : userTypeId == 3 && sortOrderNo == 2
          ? userType3SortOrderNo2Value
          : userTypeId == 3 && sortOrderNo == 3
            ? userType3SortOrderNo3Value
            : userTypeId == 3 && sortOrderNo == 4
              ? userType3SortOrderNo4Value
              : userTypeId == 3 && sortOrderNo == 5
                ? userType3SortOrderNo5Value
                : userTypeId == 3 && sortOrderNo == 6
                  ? userType3SortOrderNo6Value
                  : userTypeId == 3 && sortOrderNo == 7
                    ? userType3SortOrderNo7Value
                    : userTypeId == 3 && sortOrderNo == 8
                      ? userType3SortOrderNo8Value
                      : userTypeId == 4 && sortOrderNo == 1
                        ? userType4SortOrderNo1Value
                        : "";

    this.setState({
      salesTeamIdForExcel: value,
      userTypeId: userTypeId,
      sortOrderNo: sortOrderNo,
    });

    if (navigator.onLine) {
      if (this.checkValidation(userTypeId, sortOrderNo)) {
        if (diffDays > 7) {
          this.generateExcelByPropsNew(value);
          return;
        } else {
          let jsonToSend = {
            salesTeamIds: value.split(","),
            fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
            toDate: dayjs(toDate).format("DD-MM-YYYY"),
          };

          showLoador({ loador: true });
          getSubCategoryWiseReportBySalesTeam({ dateJson: jsonToSend }).then(
            ({ response, success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              } else {
                const {
                  categories = [],
                  subCategories = [],
                  salesTeamListWithDate = [],
                  salesTeamWithSubCategoryValues = [],
                } = response;

                const allEmpty =
                  categories.length === 0 &&
                  subCategories.length === 0 &&
                  salesTeamListWithDate.length === 0 &&
                  salesTeamWithSubCategoryValues.length === 0;

                if (allEmpty) {
                  showNotification({ msg: dataNotFoundMsg, severity: "error" });
                }

                this.setState({ dataResponseForSubCat: response });
                this.matrixDataForSubCat(response);
              }
            }
          );
        }
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSummaryHandlerTypeWise = async () => {
    const { getSalesTeamWorkingSummary, showLoador, showNotification } =
      this.props;
    const { fromDate, toDate, salesTeam } = this.state;

    const diffDays = dayjs(toDate).diff(dayjs(fromDate), "day") + 2;

    this.setState({
      underSalesTeamSummaryFlag: false,
      rowList: [],
      dataResponseForSubCat: {},
      teamWiseAnalysis: false,
    });

    if (navigator.onLine) {
      if (this.checkValidationTypeWise()) {
        if (diffDays > 7) {
          this.generateExcelForUserWorkSummaryTypeWise(salesTeam, false);
          return;
        } else {

          this.setState({ summaryTableFlag: true });

          let jsonToSend = {
            salesTeamIds: salesTeam.split(","),
            fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
            toDate: dayjs(toDate).format("DD-MM-YYYY"),
          };

          showLoador({ loador: true });
          getSalesTeamWorkingSummary({ dataJson: jsonToSend }).then(
            ({ response, success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              } else {
                if (response.length === 0) {
                  showNotification({ msg: dataNotFoundMsg, severity: "error" });
                }
              }
            }
          );
        }
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearchHandlerTypeWiseForTeamWiseSummary = () => {
    const { getUnderSalesTeamWorkingSummary, showLoador, showNotification } =
      this.props;
    const { fromDate, toDate, salesTeam } = this.state;

    const diffDays = dayjs(toDate).diff(dayjs(fromDate), "day") + 2;

    this.setState({
      underSalesTeamSummaryFlag: true,
      rowList: [],
      dataResponseForSubCat: {},
      teamWiseAnalysis: false,
    });

    if (navigator.onLine) {
      if (this.checkValidationTypeWise()) {
        if (diffDays > 7) {
          this.generateExcelForUserWorkSummaryTypeWise(salesTeam, true);
          return;
        } else {

          this.setState({ summaryTableFlag: true });
          showLoador({ loador: true });
          getUnderSalesTeamWorkingSummary({
            salesTeamId: salesTeam,
            fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
            toDate: dayjs(toDate).format("DD-MM-YYYY"),
            flag: 1,
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              if (response.length === 0) {
                showNotification({ msg: dataNotFoundMsg, severity: "error" });
              }
            }
          });
        }
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onCategoryHandlerTypeWise = () => {
    const { fromDate, toDate, stockHolderType, salesTeam } = this.state;
    const {
      getSubCategoryWiseReportBySalesTeam,
      showLoador,
      showNotification,
    } = this.props;

    const diffDays = dayjs(toDate).diff(dayjs(fromDate), "day") + 2;

    this.setState({
      summaryTableFlag: false,
      rowList: [],
    });
    if (navigator.onLine) {
      if (this.checkValidationTypeWise()) {
        if (diffDays > 7) {
          this.generateExcelByPropsNew();
          return;
        } else {
          let dataJson = {
            fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
            toDate: dayjs(toDate).format("DD-MM-YYYY"),
            salesTeamIds: salesTeam.split(","),
          };

          showLoador({ loador: true });
          getSubCategoryWiseReportBySalesTeam({ dateJson: dataJson }).then(
            ({ response, success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              } else {
                const {
                  categories = [],
                  subCategories = [],
                  salesTeamListWithDate = [],
                  salesTeamWithSubCategoryValues = [],
                } = response;

                const allEmpty =
                  categories.length === 0 &&
                  subCategories.length === 0 &&
                  salesTeamListWithDate.length === 0 &&
                  salesTeamWithSubCategoryValues.length === 0;

                if (allEmpty) {
                  showNotification({ msg: dataNotFoundMsg, severity: "error" });
                }
                this.setState({ dataResponseForSubCat: response });
                this.matrixDataForSubCat(response);
              }
            }
          );
        }
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  matrixDataForCat = (data) => {
    const { categories, salesTeamListWithDate, salesTeamWithCategoryValues } =
      data;

    const matrixDataList = salesTeamListWithDate.map((salesTeamObj, index) => {
      const salesAmounts = categories.map((categoryObj) => {
        const match = salesTeamWithCategoryValues.find(
          (salesTeamWithCategoryValuesObj) =>
            salesTeamWithCategoryValuesObj.salesTeamId == salesTeamObj.id &&
            salesTeamWithCategoryValuesObj.categoryId == categoryObj.id
        );
        return match ? match.totalAmt : "";
      });
      return {
        index: index + 1,
        salesTeamId: salesTeamObj.id,
        salesTeamName: salesTeamObj.name,
        grandTotalAmt: salesTeamObj.grandTotalAmt,
        salesAmounts,
      };
    });

    this.setState({ matrixDataListForCat: matrixDataList });
  };

  matrixDataForSubCat = (data) => {
    const {
      categories,
      subCategories,
      salesTeamListWithDate,
      salesTeamWithSubCategoryValues,
    } = data;

    const groupedData = categories.map((category) => {
      const subCategoriesForCategory = subCategories
        .filter((subcategory) => subcategory.categoryId === category.id)
        .map((subcategory) => ({
          subCatId: subcategory.id,
          subCatName: subcategory.name,
        }));

      return {
        catId: category.id,
        name: category.name,
        subCategory: subCategoriesForCategory,
      };
    });

    const subCatListWithValue = salesTeamListWithDate.map((salesTeam) => {
      const salesDataForTeam = salesTeamWithSubCategoryValues.filter(
        (item) =>
          item.salesTeamId == salesTeam.id && item.date == salesTeam.ymdDate
      );

      const categoryList = groupedData.map((category) => {
        const subCategoryWithValues = category.subCategory.map(
          (subCategory) => {
            const matchingSalesData = salesDataForTeam.find(
              (sales) => sales.subCategoryId == subCategory.subCatId
            );

            return {
              subCatId: subCategory.subCatId,
              subCatName: subCategory.subCatName,
              totalAmt: matchingSalesData ? matchingSalesData.totalAmt : 0,
            };
          }
        );

        return {
          catId: category.catId,
          name: category.name,
          subCategory: subCategoryWithValues,
        };
      });

      return {
        id: salesTeam.id,
        name: salesTeam.name,
        dmyDate: salesTeam.dmyDate,
        employeeCode: salesTeam.employeeCode,
        grandTotalAmt: salesTeam.grandTotalAmt,
        categoryList: categoryList,
      };
    });

    this.setState({
      matrixDataListForSubCat: subCatListWithValue,
      catsubCatMatrixData: groupedData,
    });
  };

  generateExcelUserSummaryEmployeeWise = (salesTeam, isTeamWiseAnalysis) => {
    const { stockStakeHolderTypeList, showLoador, showNotification } =
      this.props;

    const {
      fromDate,
      toDate,
      salesTeamIdForExcel,
      userTypeId,
      sortOrderNo,
      teamWiseAnalysis,
    } = this.state;

    this.setState({
      rowList: [],
    })

    let stockStakeHolderList =
      stockStakeHolderTypeList?.stockStakeHolderType.filter(
        (row) => row.userType.id == userTypeId && row.sortOrder == sortOrderNo
      );

    if (navigator.onLine) {
      if (isTeamWiseAnalysis) {
        let excelJson = {
          salesTeamId: salesTeamIdForExcel ? salesTeamIdForExcel : salesTeam,
          fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
          toDate: dayjs(toDate).format("DD-MM-YYYY"),
          flag: "1",
        };

        showLoador({ loador: true });
        downloadF({
          isGet: false,
          url: endpoint.manager + "/user-summary-for-below-sales-team-excel",
          postBody: excelJson,
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      } else {
        let excelJson = {
          stockStakeHolderTypeId:
            stockStakeHolderList.length != 0 ? stockStakeHolderList[0].id : "",
          salesTeamId: salesTeamIdForExcel ? salesTeamIdForExcel : salesTeam,
          userTypeId: userTypeId,
          fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
          toDate: dayjs(toDate).format("DD-MM-YYYY"),
        };

        showLoador({ loador: true });
        downloadF({
          isGet: false,
          url: endpoint.manager + "/user-summary-excel",
          postBody: excelJson,
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  generateExcelUserSummaryEmployeeWiseOnTable = () => {
    const { stockStakeHolderTypeList, showLoador, showNotification } =
      this.props;

    const {
      fromDate,
      toDate,
      salesTeamIdForExcel,
      userTypeId,
      sortOrderNo,
      teamWiseAnalysis,
    } = this.state;

    let stockStakeHolderList =
      stockStakeHolderTypeList?.stockStakeHolderType.filter(
        (row) => row.userType.id == userTypeId && row.sortOrder == sortOrderNo
      );

    if (navigator.onLine) {
      if (teamWiseAnalysis) {
        let excelJson = {
          salesTeamId: salesTeamIdForExcel,
          fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
          toDate: dayjs(toDate).format("DD-MM-YYYY"),
          flag: "1",
        };

        showLoador({ loador: true });
        downloadF({
          isGet: false,
          url: endpoint.manager + "/user-summary-for-below-sales-team-excel",
          postBody: excelJson,
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      } else {
        let excelJson = {
          stockStakeHolderTypeId:
            stockStakeHolderList.length != 0 ? stockStakeHolderList[0].id : "",
          salesTeamId: salesTeamIdForExcel,
          userTypeId: userTypeId,
          fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
          toDate: dayjs(toDate).format("DD-MM-YYYY"),
        };

        showLoador({ loador: true });
        downloadF({
          isGet: false,
          url: endpoint.manager + "/user-summary-excel",
          postBody: excelJson,
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }

  }

  generateExcelForUserWorkSummaryEmployeeWise = (
    salesTeam,
    isUnderSalesTeamSummaryFlag
  ) => {
    const { stockStakeHolderTypeList, showLoador, showNotification } =
      this.props;

    const {
      fromDate,
      toDate,
      salesTeamIdForExcel,
      userTypeId,
      sortOrderNo,
      underSalesTeamSummaryFlag,
    } = this.state;

    if (navigator.onLine) {
      let salesTeamForSend = salesTeamIdForExcel
        ? salesTeamIdForExcel
        : salesTeam;

      this.setState({ summaryTableFlag: false });


      if (isUnderSalesTeamSummaryFlag) {
        showLoador({ loador: true });
        downloadF({
          isGet: true,
          url:
            endpoint.manager +
            "/under-sales-team-working-summary-excel?salesTeamId=" +
            salesTeamForSend +
            "&fromDate=" +
            dayjs(fromDate).format("DD-MM-YYYY") +
            "&toDate=" +
            dayjs(toDate).format("DD-MM-YYYY") +
            "&flag=1",
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      } else {
        let excelJson = {
          salesTeamIds: salesTeamForSend.split(","),
          fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
          toDate: dayjs(toDate).format("DD-MM-YYYY"),
        };

        showLoador({ loador: true });
        downloadF({
          isGet: false,
          url: endpoint.manager + "/working-summary-excel",
          postBody: excelJson,
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  generateExcelForUserWorkSummaryEmployeeWiseOnTable = () => {
    const { stockStakeHolderTypeList, showLoador, showNotification } =
      this.props;

    const {
      fromDate,
      toDate,
      salesTeamIdForExcel,
      userTypeId,
      sortOrderNo,
      underSalesTeamSummaryFlag,
    } = this.state;

    if (navigator.onLine) {

      if (underSalesTeamSummaryFlag) {
        showLoador({ loador: true });
        downloadF({
          isGet: true,
          url:
            endpoint.manager +
            "/under-sales-team-working-summary-excel?salesTeamId=" +
            salesTeamIdForExcel +
            "&fromDate=" +
            dayjs(fromDate).format("DD-MM-YYYY") +
            "&toDate=" +
            dayjs(toDate).format("DD-MM-YYYY") +
            "&flag=1",
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      } else {
        let excelJson = {
          salesTeamIds: salesTeamIdForExcel.split(","),
          fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
          toDate: dayjs(toDate).format("DD-MM-YYYY"),
        };

        showLoador({ loador: true });
        downloadF({
          isGet: false,
          url: endpoint.manager + "/working-summary-excel",
          postBody: excelJson,
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };


  generateExcelForUserSummaryTypeWise = (salesTeamIds, isTypeWiseAnalysis) => {
    const { showLoador, showNotification } = this.props;
    const { fromDate, toDate, salesTeam, stockHolderType } =
      this.state;

    this.setState({
      rowList: [],
    })

    if (navigator.onLine) {
      if (isTypeWiseAnalysis) {
        let excelJson = {
          salesTeamId: salesTeam ? salesTeam : salesTeamIds,
          fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
          toDate: dayjs(toDate).format("DD-MM-YYYY"),
          flag: "1",
        };

        showLoador({ loador: true });
        downloadF({
          isGet: false,
          url: endpoint.manager + "/user-summary-for-below-sales-team-excel",
          postBody: excelJson,
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      } else {
        let excelJson = {
          stockStakeHolderTypeId: stockHolderType,
          salesTeamId: salesTeam ? salesTeam : salesTeamIds,
          userTypeId: "",
          fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
          toDate: dayjs(toDate).format("DD-MM-YYYY"),
        };

        showLoador({ loador: true });
        downloadF({
          isGet: false,
          url: endpoint.manager + "/user-summary-excel",
          postBody: excelJson,
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  generateExcelForUserSummaryTypeWiseOnTable = () => {
    const { showLoador, showNotification } = this.props;
    const { fromDate, toDate, salesTeam, stockHolderType, teamWiseAnalysis } =
      this.state;

    if (navigator.onLine) {
      if (teamWiseAnalysis) {
        let excelJson = {
          salesTeamId: salesTeam,
          fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
          toDate: dayjs(toDate).format("DD-MM-YYYY"),
          flag: "1",
        };

        showLoador({ loador: true });
        downloadF({
          isGet: false,
          url: endpoint.manager + "/user-summary-for-below-sales-team-excel",
          postBody: excelJson,
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      } else {
        let excelJson = {
          stockStakeHolderTypeId: stockHolderType,
          salesTeamId: salesTeam,
          userTypeId: "",
          fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
          toDate: dayjs(toDate).format("DD-MM-YYYY"),
        };

        showLoador({ loador: true });
        downloadF({
          isGet: false,
          url: endpoint.manager + "/user-summary-excel",
          postBody: excelJson,
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  generateExcelForUserWorkSummaryTypeWise = async (salesTeamIds, isUnderSalesTeamSummaryFlag) => {
    const { showLoador, showNotification } = this.props;
    const { fromDate, toDate, salesTeam } =
      this.state;

    let salesTeamForSend = salesTeam ? salesTeam : salesTeamIds;

    if (navigator.onLine) {

      this.setState({ summaryTableFlag: false })
      if (isUnderSalesTeamSummaryFlag) {
        showLoador({ loador: true });
        await downloadF({
          isGet: true,
          url:
            endpoint.manager +
            "/under-sales-team-working-summary-excel?salesTeamId=" +
            salesTeamForSend +
            "&fromDate=" +
            dayjs(fromDate).format("DD-MM-YYYY") +
            "&toDate=" +
            dayjs(toDate).format("DD-MM-YYYY") +
            "&flag=1",
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      } else {
        let excelJson = {
          salesTeamIds: salesTeamForSend.split(","),
          fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
          toDate: dayjs(toDate).format("DD-MM-YYYY"),
        };

        showLoador({ loador: true });
        await downloadF({
          isGet: false,
          url: endpoint.manager + "/working-summary-excel",
          postBody: excelJson,
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  generateExcelForUserWorkSummaryTypeWiseOnTable = async () => {
    const { showLoador, showNotification } = this.props;
    const { fromDate, toDate, salesTeam, underSalesTeamSummaryFlag } =
      this.state;

    if (navigator.onLine) {
      if (underSalesTeamSummaryFlag) {
        showLoador({ loador: true });
        await downloadF({
          isGet: true,
          url:
            endpoint.manager +
            "/under-sales-team-working-summary-excel?salesTeamId=" +
            salesTeam +
            "&fromDate=" +
            dayjs(fromDate).format("DD-MM-YYYY") +
            "&toDate=" +
            dayjs(toDate).format("DD-MM-YYYY") +
            "&flag=1",
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      } else {
        let excelJson = {
          salesTeamIds: salesTeam.split(","),
          fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
          toDate: dayjs(toDate).format("DD-MM-YYYY"),
        };

        showLoador({ loador: true });
        await downloadF({
          isGet: false,
          url: endpoint.manager + "/working-summary-excel",
          postBody: excelJson,
          ext: "xlsx",
          openNewTab: true,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };


  salesTeamHandler = (e, salesTeamId) => {
    const {
      getSelectedBeatCountFromSalesTeamIdAndDate,
      showLoador,
      showNotification,
    } = this.props;
    const { fromDate, toDate } = this.state;

    if (navigator.onLine) {
      showLoador({ loador: true });
      getSelectedBeatCountFromSalesTeamIdAndDate({
        salesTeamId: salesTeamId,
        fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
        toDate: dayjs(toDate).format("DD-MM-YYYY"),
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.setState({
            beatPopUpFlag: true,
          });
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  handleClosesSalesTeam = () => {
    this.setState({
      beatPopUpFlag: false,
    });
  };

  changeDate = (name) => (date) => {
    this.setState({
      [name]: date,
    });
  };

  onAutocompleteChange = (userTypeAndSortOrder, newValue) => {
    const { stockStakeHolderTypeList } = this.props;
    const {
      userType3SortOrderNo1Flag,
      userType3SortOrderNo2Flag,
      userType3SortOrderNo3Flag,
      userType3SortOrderNo4Flag,
      userType3SortOrderNo5Flag,
      userType3SortOrderNo6Flag,
      userType3SortOrderNo7Flag,
      userType3SortOrderNo8Flag,
      userType4SortOrderNo1Flag,
    } = this.state;
    let userTypeValue =
      userTypeAndSortOrder == userType4SortOrderNo1Flag ? 4 : 3;
    let sortOrderValue = "";
    if (userTypeAndSortOrder == userType3SortOrderNo1Flag) {
      sortOrderValue = 1;
      this.setState({
        userType3SortOrderNo1Value: newValue,
      });
    } else if (userTypeAndSortOrder == userType3SortOrderNo2Flag) {
      sortOrderValue = 2;
      this.setState({
        userType3SortOrderNo2Value: newValue,
      });
    } else if (userTypeAndSortOrder == userType3SortOrderNo3Flag) {
      sortOrderValue = 3;
      this.setState({
        userType3SortOrderNo3Value: newValue,
      });
    } else if (userTypeAndSortOrder == userType3SortOrderNo4Flag) {
      sortOrderValue = 4;
      this.setState({
        userType3SortOrderNo4Value: newValue,
      });
    } else if (userTypeAndSortOrder == userType3SortOrderNo5Flag) {
      sortOrderValue = 5;
      this.setState({
        userType3SortOrderNo5Value: newValue,
      });
    } else if (userTypeAndSortOrder == userType3SortOrderNo6Flag) {
      sortOrderValue = 6;
      this.setState({
        userType3SortOrderNo6Value: newValue,
      });
    } else if (userTypeAndSortOrder == userType3SortOrderNo7Flag) {
      sortOrderValue = 7;
      this.setState({
        userType3SortOrderNo7Value: newValue,
      });
    } else if (userTypeAndSortOrder == userType3SortOrderNo8Flag) {
      sortOrderValue = 8;
      this.setState({
        userType3SortOrderNo8Value: newValue,
      });
    } else {
      sortOrderValue = 1;
      this.setState({
        userType4SortOrderNo1Value: newValue,
      });
    }

    this.setState({
      rowList: [],
    });

    if (
      newValue != null &&
      userTypeAndSortOrder !== userType4SortOrderNo1Flag
    ) {
      let stockStakeHolderList =
        stockStakeHolderTypeList?.stockStakeHolderType.filter(
          (row) =>
            row.userType.id == userTypeValue && row.sortOrder == sortOrderValue
        );

      this.getListById(stockStakeHolderList[0], newValue);
    }
  };

  onAutocompleteChangeTypeWise = (name, newValue) => {
    const { showLoador, showNotification, getSalesExecutive } = this.props;

    if (name === "stockHolderType") {
      this.setState({
        stockHolderType: newValue,
      });

      showLoador({ loador: true });
      getSalesExecutive({ stockStakeHolderId: newValue }).then(
        ({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        }
      );
    }

    if (name === "salesTeam") {
      this.setState({
        salesTeam: newValue,
      });
    }
  };

  onRadioChange = (e) => {
    const { value, name } = e.target;
    const { setSalesTeamWorkingSummary } = this.props;

    this.setState({
      rowList: [],
      dataResponseForSubCat: {},
      matrixDataListForSubCat: [],
    });

    setSalesTeamWorkingSummary({ row: [] });

    if (name == "radioType") {
      this.setState({
        radioType: value,
      });
    }
  };

  checkValidation = (userTypeId, sortOrderNo) => {
    const {
      userType3SortOrderNo1Value,
      userType3SortOrderNo2Value,
      userType3SortOrderNo3Value,
      userType3SortOrderNo4Value,
      userType3SortOrderNo5Value,
      userType3SortOrderNo6Value,
      userType3SortOrderNo7Value,
      userType3SortOrderNo8Value,
      userType4SortOrderNo1Value,
    } = this.state;

    let formErrors = {};
    let formIsValid = true;

    if (userTypeId == 3 && sortOrderNo == 1) {
      if (
        userType3SortOrderNo1Value === "" ||
        userType3SortOrderNo1Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo1ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 3 && sortOrderNo == 2) {
      if (
        userType3SortOrderNo2Value === "" ||
        userType3SortOrderNo2Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo2ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 3 && sortOrderNo == 3) {
      if (
        userType3SortOrderNo3Value === "" ||
        userType3SortOrderNo3Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo3ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 3 && sortOrderNo == 4) {
      if (
        userType3SortOrderNo4Value === "" ||
        userType3SortOrderNo4Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo4ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 3 && sortOrderNo == 5) {
      if (
        userType3SortOrderNo5Value === "" ||
        userType3SortOrderNo5Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo5ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 3 && sortOrderNo == 6) {
      if (
        userType3SortOrderNo6Value === "" ||
        userType3SortOrderNo6Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo6ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 3 && sortOrderNo == 7) {
      if (
        userType3SortOrderNo7Value === "" ||
        userType3SortOrderNo7Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo7ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 3 && sortOrderNo == 8) {
      if (
        userType3SortOrderNo8Value === "" ||
        userType3SortOrderNo8Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo8ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 4 && sortOrderNo == 1) {
      if (
        userType4SortOrderNo1Value === "" ||
        userType4SortOrderNo1Value === null
      ) {
        formIsValid = false;
        formErrors["userType4SortOrderNo1ValueError"] = "Select Value";
      }
    }

    this.setState({ formErrors: formErrors });
    return formIsValid;
  };

  checkValidationForExcelEmployeeWise = () => {
    const {
      userType3SortOrderNo1Value,
      userType3SortOrderNo2Value,
      userType3SortOrderNo3Value,
      userType3SortOrderNo4Value,
      userType3SortOrderNo5Value,
      userType3SortOrderNo6Value,
      userType3SortOrderNo7Value,
      userType3SortOrderNo8Value,
      userType4SortOrderNo1Value,
      userTypeId,
      sortOrderNo,
    } = this.state;

    let formErrors = {};
    let formIsValid = true;

    if (userTypeId == 3 && sortOrderNo == 1) {
      if (
        userType3SortOrderNo1Value === "" ||
        userType3SortOrderNo1Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo1ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 3 && sortOrderNo == 2) {
      if (
        userType3SortOrderNo2Value === "" ||
        userType3SortOrderNo2Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo2ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 3 && sortOrderNo == 3) {
      if (
        userType3SortOrderNo3Value === "" ||
        userType3SortOrderNo3Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo3ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 3 && sortOrderNo == 4) {
      if (
        userType3SortOrderNo4Value === "" ||
        userType3SortOrderNo4Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo4ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 3 && sortOrderNo == 5) {
      if (
        userType3SortOrderNo5Value === "" ||
        userType3SortOrderNo5Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo5ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 3 && sortOrderNo == 6) {
      if (
        userType3SortOrderNo6Value === "" ||
        userType3SortOrderNo6Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo6ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 3 && sortOrderNo == 7) {
      if (
        userType3SortOrderNo7Value === "" ||
        userType3SortOrderNo7Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo7ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 3 && sortOrderNo == 8) {
      if (
        userType3SortOrderNo8Value === "" ||
        userType3SortOrderNo8Value === null
      ) {
        formIsValid = false;
        formErrors["userType3SortOrderNo8ValueError"] = "Select Value";
      }
    }

    if (userTypeId == 4 && sortOrderNo == 1) {
      if (
        userType4SortOrderNo1Value === "" ||
        userType4SortOrderNo1Value === null
      ) {
        formIsValid = false;
        formErrors["userType4SortOrderNo1ValueError"] = "Select Value";
      }
    }

    this.setState({ formErrors: formErrors });
    return formIsValid;
  };

  checkValidationTypeWise = () => {
    const { stockHolderType, salesTeam } = this.state;

    let formErrors = {};
    let formIsValid = true;

    let userType = localStorage.getItem("userTypeId");

    if (userType && userType != 3) {
      if (stockHolderType === "" || stockHolderType === null) {
        formIsValid = false;
        formErrors["stockHolderTypeError"] = "Select Stock Holder Type";
      }
    }

    if (salesTeam === "" || salesTeam === null) {
      formIsValid = false;
      formErrors["salesTeamError"] = "Select Sales Team";
    }

    this.setState({ formErrors: formErrors });
    return formIsValid;
  };

  onSearchForAnalysis = (searchValue) => {
    this.setState({
      searchValue: searchValue,
    });
  };

  getFilteredTableData = (searchData) => {
    const { searchValue } = this.state;
    if (!searchData || searchData.length === 0) {
      return [];
    }
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["employeeCode"] &&
          currentRow["employeeCode"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["name"] &&
          currentRow["name"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["stockStakeHolderTypeName"] &&
          currentRow["stockStakeHolderTypeName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["checkInTime"] &&
          currentRow["checkInTime"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["checkOutTime"] &&
          currentRow["checkOutTime"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["firstCallTime"] &&
          currentRow["firstCallTime"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["lastCallTime"] &&
          currentRow["lastCallTime"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["totalRetailCallTime"] &&
          currentRow["totalRetailCallTime"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["workingHrs"] &&
          currentRow["workingHrs"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["beatCounts"] &&
          currentRow["beatCounts"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["totalOutlet"] &&
          currentRow["totalOutlet"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["productiveOrderCall"] &&
          currentRow["productiveOrderCall"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["remoteOrderCall"] &&
          currentRow["remoteOrderCall"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["zeroOrdeCall"] &&
          currentRow["zeroOrdeCall"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["totalOrderCall"] &&
          currentRow["totalOrderCall"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["totalOrderAmt"] &&
          currentRow["totalOrderAmt"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  onSearchForSummary = (searchValue) => {
    this.setState({
      searchValue: searchValue,
    });
  };

  getFilteredTableDataForSummaryTable = (searchData) => {
    const { searchValue } = this.state;
    if (!searchData || searchData.length === 0) {
      return [];
    }
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["date"] &&
          currentRow["date"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["employeeCode"] &&
          currentRow["employeeCode"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["salesTeamName"] &&
          currentRow["salesTeamName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["stockStakeHolderTypeName"] &&
          currentRow["stockStakeHolderTypeName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["workingTypeName"] &&
          currentRow["workingTypeName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["otherTaskName"] &&
          currentRow["otherTaskName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["fromTime"] &&
          currentRow["fromTime"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["toTime"] &&
          currentRow["toTime"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["reason"] &&
          currentRow["reason"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["firmName"] &&
          currentRow["firmName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  generateExcelByPropsNew = (salesTeamIds) => {
    const { showLoador, showNotification } = this.props;
    const { salesTeam, fromDate, toDate } = this.state;

    let salesTeamForSend = salesTeam ? salesTeam : salesTeamIds;

    if (navigator.onLine) {
      let dateJson = {
        salesTeamIds: salesTeamForSend.split(","),
        fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
        toDate: dayjs(toDate).format("DD-MM-YYYY"),
      };

      showLoador({ loador: true });
      downloadF({
        isGet: false,
        url:
          endpoint.reportForExcelReports +
          "/sub-category-wise-report-excel-by-sales-teams",
        postBody: dateJson,
        ext: "xlsx",
        openNewTab: true,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  generateExcelByProps = () => {
    const { showLoador, showNotification } = this.props;
    const { salesTeamIdForExcel, fromDate, toDate, salesTeam } = this.state;

    let salesTeamForSend = salesTeamIdForExcel
      ? salesTeamIdForExcel
      : salesTeam;

    if (navigator.onLine) {
      let dateJson = {
        salesTeamIds: salesTeamForSend.split(","),
        fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
        toDate: dayjs(toDate).format("DD-MM-YYYY"),
      };

      showLoador({ loador: true });
      downloadF({
        isGet: false,
        url:
          endpoint.reportForExcelReports +
          "/sub-category-wise-report-excel-by-sales-teams",
        postBody: dateJson,
        ext: "xlsx",
        openNewTab: true,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  render() {
    const {
      beatList,
      stockStakeHolderTypeList,
      salesExecutiveList,
      managerList,
    } = this.props;
    const {
      formErrors,
      rowList,
      beatPopUpFlag,
      fromDate,
      toDate,
      radioType,
      summaryTableFlag,
      stockHolderType,
      salesTeam,
      dateFlag,

      userType3SortOrderNo1Flag,
      userType3SortOrderNo2Flag,
      userType3SortOrderNo3Flag,
      userType3SortOrderNo4Flag,
      userType3SortOrderNo5Flag,
      userType3SortOrderNo6Flag,
      userType3SortOrderNo7Flag,
      userType3SortOrderNo8Flag,
      userType4SortOrderNo1Flag,

      userType3SortOrderNo1List,
      userType3SortOrderNo2List,
      userType3SortOrderNo3List,
      userType3SortOrderNo4List,
      userType3SortOrderNo5List,
      userType3SortOrderNo6List,
      userType3SortOrderNo7List,
      userType3SortOrderNo8List,
      userType4SortOrderNo1List,

      userType3SortOrderNo1Value,
      userType3SortOrderNo2Value,
      userType3SortOrderNo3Value,
      userType3SortOrderNo4Value,
      userType3SortOrderNo5Value,
      userType3SortOrderNo6Value,
      userType3SortOrderNo7Value,
      userType3SortOrderNo8Value,
      userType4SortOrderNo1Value,
      subCategories,
      categories,
      salesTeamSubCategoryWiseReportData,
      salesTeamListWithDate,
      salesTeamWithSubCategoryValues,
      dataResponseForSubCat,
      catsubCatMatrixData,
      matrixDataListForSubCat,
      isShowCategoryWiseAnalysis,
      teamWiseAnalysis,
    } = this.state;

    return (
      <>
        <Paper
          sx={{
            paddingTop: 2,
            borderRadius: 2,
            px: "2%",
          }}
          elevation={0}
        // style={{ width: "100%" }}
        >
          <LandingScreenHeader
            screenTitle={"User Summary"}
            showAddButton={false}
            showBackButton={false}
          // onCancel={onCancel}
          />
          <br />

          <Grid
            item
            sm={12}
            xs={12}
            md={12}
            lg={12}
            container
            justifyContent="left"
          >
            <Grid item xs={12} md={7} sm={7}>
              <RadioGroup
                row
                aria-label={"radioType"}
                name={"radioType"}
                id={"radioType"}
                value={radioType}
                onChange={this.onRadioChange}
                size="small"
              >
                {localStorage.getItem("userTypeId") &&
                  localStorage.getItem("userTypeId") != 3 && (
                    <>
                      <FormControlLabel
                        value={"0"}
                        control={<Radio />}
                        label={"Employee Wise"}
                      />
                      <FormControlLabel
                        value={"1"}
                        control={<Radio />}
                        label={"Type Wise"}
                      />
                    </>
                  )}
                {localStorage.getItem("userTypeId") &&
                  localStorage.getItem("userTypeId") == 3 && (
                    <FormControlLabel
                      value={"2"}
                      control={<Radio />}
                      label={"Team Wise"}
                    />
                  )}

              </RadioGroup>
            </Grid>
          </Grid>
          <br />

          <>
            {radioType == 0 ? (
              <>
                <Grid
                  container
                  spacing={3}
                  sm={12}
                  xs={12}
                  md={12}
                  lg={12}
                  display="flex"
                  justifyContent="space-between"
                >
                  {/* From Date */}
                  <Grid item sm={6} xs={12} md={4} lg={4}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: redColor }}
                      label={"*"}
                    />
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: titleColor }}
                      label={"From Date :"}
                    />
                    <BasicDatePicker
                      color="primary"
                      name="fromDate"
                      size="small"
                      value={fromDate}
                      disabled={false}
                      fullWidth
                      onChange={this.changeDate("fromDate")}
                      errorText={" "}
                      isError={false}
                    />
                  </Grid>

                  {/* To Date */}
                  <Grid item sm={6} xs={12} md={4} lg={4}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: redColor }}
                      label={"*"}
                    />
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: titleColor }}
                      label={"To Date :"}
                    />
                    <BasicDatePicker
                      color="primary"
                      name="toDate"
                      size="small"
                      value={toDate}
                      disabled={false}
                      fullWidth
                      onChange={this.changeDate("toDate")}
                      errorText={" "}
                      isError={false}
                    />
                  </Grid>

                  {/* Spacer to complete 12-column grid */}
                  <Grid item sm={0} xs={false} md={4} lg={4} />
                </Grid>
              </>
            ) : (
              <Grid
                container
                spacing={3}
                alignItems="center"
                justifyContent="flex-start"
              >
                <Grid item xs={12} sm={4} md={4} lg={4}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: redColor, marginRight: 4 }}
                      label={"*"}
                    />
                    <LabelCompo
                      className="text-black"
                      style={{
                        fontSize: 16,
                        color: titleColor,
                        marginRight: 8,
                      }}
                      label={"From Date :"}
                    />
                  </div>
                  <BasicDatePicker
                    color="primary"
                    name="fromDate"
                    size="small"
                    value={fromDate}
                    disabled={false}
                    fullWidth
                    onChange={this.changeDate("fromDate")}
                    errorText={" "}
                    isError={false}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: redColor, marginRight: 4 }}
                      label={"*"}
                    />
                    <LabelCompo
                      className="text-black"
                      style={{
                        fontSize: 16,
                        color: titleColor,
                        marginRight: 8,
                      }}
                      label={"To Date :"}
                    />
                  </div>
                  <BasicDatePicker
                    color="primary"
                    name="toDate"
                    size="small"
                    value={toDate}
                    disabled={false}
                    fullWidth
                    onChange={this.changeDate("toDate")}
                    errorText={" "}
                    isError={false}
                  />
                </Grid>
              </Grid>
            )}
          </>

          {radioType == 0 ? (
            <>
              {userType3SortOrderNo1List.length != 0 && (
                <Grid
                  container
                  sm={12}
                  xs={12}
                  md={12}
                  lg={12}
                  display="flex"
                  justifyContent="space-between"
                >
                  {/* Left Dropdown */}
                  <Grid item sm={3.8} xs={12} md={3.8} lg={3.8}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: redColor }}
                      label={"*"}
                    />
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: titleColor }}
                      label={
                        userType3SortOrderNo1Flag.stockStakeHolderTypeName +
                        " :"
                      }
                    />
                    <AutoComplete
                      name={userType3SortOrderNo1Flag}
                      label={""}
                      placeHolder={"SELECT VALUE"}
                      keyColName={"id"}
                      value={userType3SortOrderNo1Value}
                      options={userType3SortOrderNo1List}
                      onChange={this.onAutocompleteChange}
                      errorText={
                        formErrors["userType3SortOrderNo1ValueError"] || ""
                      }
                      isError={
                        formErrors["userType3SortOrderNo1ValueError"] || ""
                      }
                    />
                  </Grid>

                  {/* Buttons - Increased Width */}
                  <Grid
                    item
                    display="flex"
                    alignItems="flex-end"
                    gap={2}
                    sm={8}
                    xs={12}
                    md={8}
                    lg={8}
                  >
                    <ButtonCompo
                      size="medium"
                      type="submit"
                      variant="contained"
                      name={"Analysis"}
                      onClick={() => this.onSearchHandler(3, 1)}
                    />
                    <ButtonCompo
                      size="medium"
                      type="submit"
                      variant="contained"
                      name={"Summary"}
                      onClick={() => this.onSummaryHandler(3, 1)}
                    />
                    {isShowCategoryWiseAnalysis == 1 && (
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Category Wise Analysis"}
                        onClick={() => this.onCategoryHandler(3, 1)}
                      />
                    )}
                    <ButtonCompo
                      size="medium"
                      type="submit"
                      variant="contained"
                      name={"Team Wise Analysis"}
                      onClick={() => this.onSearchHandlerForSalesTeam(3, 1)}
                    />

                    <ButtonCompo
                      size="medium"
                      type="submit"
                      variant="contained"
                      name={"Team Wise Summary"}
                      onClick={() =>
                        this.onSearchHandlerForTeamWiseSummary(3, 1)
                      }
                    />
                  </Grid>

                  {/* <Grid item sm={0} xs={12} md={0} lg={0} /> */}
                </Grid>
              )}
              <br />
              {userType3SortOrderNo2List.length != 0 && (
                <>
                  <Grid
                    sm={12}
                    xs={12}
                    md={12}
                    lg={12}
                    container
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Grid item sm={3.8} xs={12} md={3.8} lg={3.8}>
                      <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16, color: redColor }}
                        label={"*"}
                      />
                      <LabelCompo
                        className="text-black"
                        style={{
                          fontSize: 16,
                          color: titleColor,
                        }}
                        label={userType3SortOrderNo2Flag.name + " :"}
                      />{" "}
                      <AutoComplete
                        name={userType3SortOrderNo2Flag}
                        label={""}
                        placeHolder={"SELECT VALUE"}
                        keyColName={"id"}
                        value={userType3SortOrderNo2Value}
                        options={userType3SortOrderNo2List}
                        onChange={this.onAutocompleteChange}
                        errorText={
                          formErrors["userType3SortOrderNo2ValueError"]
                            ? formErrors["userType3SortOrderNo2ValueError"]
                            : ""
                        }
                        isError={
                          formErrors["userType3SortOrderNo2ValueError"]
                            ? formErrors["userType3SortOrderNo2ValueError"]
                            : ""
                        }
                      />
                    </Grid>

                    <Grid
                      item
                      display="flex"
                      alignItems="flex-end"
                      gap={2}
                      sm={8}
                      xs={12}
                      md={8}
                      lg={8}
                    >
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Analysis"}
                        onClick={() => this.onSearchHandler(3, 2)}
                      />

                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Summary"}
                        onClick={() => this.onSummaryHandler(3, 2)}
                      />
                      {isShowCategoryWiseAnalysis == 1 && (
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Category Wise Analysis"}
                          onClick={() => this.onCategoryHandler(3, 2)}
                        />
                      )}
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Team Wise Analysis"}
                        onClick={() => this.onSearchHandlerForSalesTeam(3, 2)}
                      />

                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Team Wise Summary"}
                        onClick={() =>
                          this.onSearchHandlerForTeamWiseSummary(3, 2)
                        }
                      />
                    </Grid>
                  </Grid>
                  <br />
                </>
              )}
              {userType3SortOrderNo3List.length != 0 && (
                <>
                  <Grid
                    sm={12}
                    xs={12}
                    md={12}
                    lg={12}
                    container
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Grid item sm={3.8} xs={12} md={3.8} lg={3.8}>
                      <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16, color: redColor }}
                        label={"*"}
                      />
                      <LabelCompo
                        className="text-black"
                        style={{
                          fontSize: 16,
                          color: titleColor,
                        }}
                        label={userType3SortOrderNo3Flag.name + " :"}
                      />{" "}
                      <AutoComplete
                        name={userType3SortOrderNo3Flag}
                        label={""}
                        placeHolder={"SELECT VALUE"}
                        keyColName={"id"}
                        value={userType3SortOrderNo3Value}
                        options={userType3SortOrderNo3List}
                        onChange={this.onAutocompleteChange}
                        errorText={
                          formErrors["userType3SortOrderNo3ValueError"]
                            ? formErrors["userType3SortOrderNo3ValueError"]
                            : ""
                        }
                        isError={
                          formErrors["userType3SortOrderNo3ValueError"]
                            ? formErrors["userType3SortOrderNo3ValueError"]
                            : ""
                        }
                      />
                    </Grid>

                    <Grid
                      item
                      display="flex"
                      alignItems="flex-end"
                      gap={2}
                      sm={8}
                      xs={12}
                      md={8}
                      lg={8}
                    >
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Analysis"}
                        onClick={() => this.onSearchHandler(3, 3)}
                      />

                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Summary"}
                        onClick={() => this.onSummaryHandler(3, 3)}
                      />
                      {isShowCategoryWiseAnalysis == 1 && (
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Category Wise Analysis"}
                          onClick={() => this.onCategoryHandler(3, 3)}
                        />
                      )}
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Team Wise Analysis"}
                        onClick={() => this.onSearchHandlerForSalesTeam(3, 3)}
                      />

                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Team Wise Summary"}
                        onClick={() =>
                          this.onSearchHandlerForTeamWiseSummary(3, 3)
                        }
                      />
                    </Grid>
                  </Grid>
                  <br />
                </>
              )}
              {userType3SortOrderNo4List.length != 0 && (
                <>
                  <Grid
                    sm={12}
                    xs={12}
                    md={12}
                    lg={12}
                    container
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Grid item sm={3.8} xs={12} md={3.8} lg={3.8}>
                      <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16, color: redColor }}
                        label={"*"}
                      />
                      <LabelCompo
                        className="text-black"
                        style={{
                          fontSize: 16,
                          color: titleColor,
                        }}
                        label={userType3SortOrderNo4Flag.name + " :"}
                      />{" "}
                      <AutoComplete
                        name={userType3SortOrderNo4Flag}
                        label={""}
                        placeHolder={"SELECT VALUE"}
                        keyColName={"id"}
                        value={userType3SortOrderNo4Value}
                        options={userType3SortOrderNo4List}
                        onChange={this.onAutocompleteChange}
                        errorText={
                          formErrors["userType3SortOrderNo4ValueError"]
                            ? formErrors["userType3SortOrderNo4ValueError"]
                            : ""
                        }
                        isError={
                          formErrors["userType3SortOrderNo4ValueError"]
                            ? formErrors["userType3SortOrderNo4ValueError"]
                            : ""
                        }
                      />
                    </Grid>

                    <Grid
                      item
                      display="flex"
                      alignItems="flex-end"
                      gap={2}
                      sm={8}
                      xs={12}
                      md={8}
                      lg={8}
                    >
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Analysis"}
                        onClick={() => this.onSearchHandler(3, 4)}
                      />

                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Summary"}
                        onClick={() => this.onSummaryHandler(3, 4)}
                      />
                      {isShowCategoryWiseAnalysis == 1 && (
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Category Wise Analysis"}
                          onClick={() => this.onCategoryHandler(3, 4)}
                        />
                      )}
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Team Wise Analysis"}
                        onClick={() => this.onSearchHandlerForSalesTeam(3, 4)}
                      />

                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Team Wise Summary"}
                        onClick={() =>
                          this.onSearchHandlerForTeamWiseSummary(3, 4)
                        }
                      />
                    </Grid>
                  </Grid>
                  <br />
                </>
              )}
              {userType3SortOrderNo5List.length != 0 && (
                <>
                  <Grid
                    sm={12}
                    xs={12}
                    md={12}
                    lg={12}
                    container
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Grid item sm={3.8} xs={12} md={3.8} lg={3.8}>
                      <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16, color: redColor }}
                        label={"*"}
                      />
                      <LabelCompo
                        className="text-black"
                        style={{
                          fontSize: 16,
                          color: titleColor,
                        }}
                        label={userType3SortOrderNo5Flag.name + " :"}
                      />{" "}
                      <AutoComplete
                        name={userType3SortOrderNo5Flag}
                        label={""}
                        placeHolder={"SELECT VALUE"}
                        keyColName={"id"}
                        value={userType3SortOrderNo5Value}
                        options={userType3SortOrderNo5List}
                        onChange={this.onAutocompleteChange}
                        errorText={
                          formErrors["userType3SortOrderNo5ValueError"]
                            ? formErrors["userType3SortOrderNo5ValueError"]
                            : ""
                        }
                        isError={
                          formErrors["userType3SortOrderNo5ValueError"]
                            ? formErrors["userType3SortOrderNo5ValueError"]
                            : ""
                        }
                      />
                    </Grid>

                    <Grid
                      item
                      display="flex"
                      alignItems="flex-end"
                      gap={2}
                      sm={8}
                      xs={12}
                      md={8}
                      lg={8}
                    >
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Analysis"}
                        onClick={() => this.onSearchHandler(3, 5)}
                      />

                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Summary"}
                        onClick={() => this.onSummaryHandler(3, 5)}
                      />
                      {isShowCategoryWiseAnalysis == 1 && (
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Category Wise Analysis"}
                          onClick={() => this.onCategoryHandler(3, 5)}
                        />
                      )}
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Team Wise Analysis"}
                        onClick={() => this.onSearchHandlerForSalesTeam(3, 5)}
                      />
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Team Wise Summary"}
                        onClick={() =>
                          this.onSearchHandlerForTeamWiseSummary(3, 5)
                        }
                      />
                    </Grid>
                  </Grid>
                  <br />
                </>
              )}
              {userType3SortOrderNo6List.length != 0 && (
                <>
                  <Grid
                    sm={12}
                    xs={12}
                    md={12}
                    lg={12}
                    container
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Grid item sm={3.8} xs={12} md={3.8} lg={3.8}>
                      <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16, color: redColor }}
                        label={"*"}
                      />
                      <LabelCompo
                        className="text-black"
                        style={{
                          fontSize: 16,
                          color: titleColor,
                        }}
                        label={userType3SortOrderNo6Flag.name + " :"}
                      />{" "}
                      <AutoComplete
                        name={userType3SortOrderNo6Flag}
                        label={""}
                        placeHolder={"SELECT VALUE"}
                        keyColName={"id"}
                        value={userType3SortOrderNo6Value}
                        options={userType3SortOrderNo6List}
                        onChange={this.onAutocompleteChange}
                        errorText={
                          formErrors["userType3SortOrderNo6ValueError"]
                            ? formErrors["userType3SortOrderNo6ValueError"]
                            : ""
                        }
                        isError={
                          formErrors["userType3SortOrderNo6ValueError"]
                            ? formErrors["userType3SortOrderNo6ValueError"]
                            : ""
                        }
                      />
                    </Grid>

                    <Grid
                      item
                      display="flex"
                      alignItems="flex-end"
                      gap={2}
                      sm={8}
                      xs={12}
                      md={8}
                      lg={8}
                    >
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Analysis"}
                        onClick={() => this.onSearchHandler(3, 6)}
                      />

                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Summary"}
                        onClick={() => this.onSummaryHandler(3, 6)}
                      />
                      {isShowCategoryWiseAnalysis == 1 && (
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Category Wise Analysis"}
                          onClick={() => this.onCategoryHandler(3, 6)}
                        />
                      )}
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Team Wise Analysis"}
                        onClick={() => this.onSearchHandlerForSalesTeam(3, 6)}
                      />
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Team Wise Summary"}
                        onClick={() =>
                          this.onSearchHandlerForTeamWiseSummary(3, 6)
                        }
                      />
                    </Grid>
                  </Grid>
                  <br />
                </>
              )}
              {userType3SortOrderNo7List.length != 0 && (
                <>
                  <Grid
                    sm={12}
                    xs={12}
                    md={12}
                    lg={12}
                    container
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Grid item sm={3.8} xs={12} md={3.8} lg={3.8}>
                      <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16, color: redColor }}
                        label={"*"}
                      />
                      <LabelCompo
                        className="text-black"
                        style={{
                          fontSize: 16,
                          color: titleColor,
                        }}
                        label={userType3SortOrderNo7Flag.name + " :"}
                      />{" "}
                      <AutoComplete
                        name={userType3SortOrderNo7Flag}
                        label={""}
                        placeHolder={"SELECT VALUE"}
                        keyColName={"id"}
                        value={userType3SortOrderNo7Value}
                        options={userType3SortOrderNo7List}
                        onChange={this.onAutocompleteChange}
                        errorText={
                          formErrors["userType3SortOrderNo7ValueError"]
                            ? formErrors["userType3SortOrderNo7ValueError"]
                            : ""
                        }
                        isError={
                          formErrors["userType3SortOrderNo7ValueError"]
                            ? formErrors["userType3SortOrderNo7ValueError"]
                            : ""
                        }
                      />
                    </Grid>

                    <Grid
                      item
                      display="flex"
                      alignItems="flex-end"
                      gap={2}
                      sm={8}
                      xs={12}
                      md={8}
                      lg={8}
                    >
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Analysis"}
                        onClick={() => this.onSearchHandler(3, 7)}
                      />

                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Summary"}
                        onClick={() => this.onSummaryHandler(3, 7)}
                      />
                      {isShowCategoryWiseAnalysis == 1 && (
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Category Wise Analysis"}
                          onClick={() => this.onCategoryHandler(3, 7)}
                        />
                      )}
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Team Wise Analysis"}
                        onClick={() => this.onSearchHandlerForSalesTeam(3, 7)}
                      />
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Team Wise Summary"}
                        onClick={() =>
                          this.onSearchHandlerForTeamWiseSummary(3, 7)
                        }
                      />
                    </Grid>
                  </Grid>
                  <br />
                </>
              )}
              {userType3SortOrderNo8List.length != 0 && (
                <>
                  <Grid
                    sm={12}
                    xs={12}
                    md={12}
                    lg={12}
                    container
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Grid item sm={3.8} xs={12} md={3.8} lg={3.8}>
                      <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16, color: redColor }}
                        label={"*"}
                      />
                      <LabelCompo
                        className="text-black"
                        style={{
                          fontSize: 16,
                          color: titleColor,
                        }}
                        label={userType3SortOrderNo8Flag.name + " :"}
                      />{" "}
                      <AutoComplete
                        name={userType3SortOrderNo8Flag}
                        label={""}
                        placeHolder={"SELECT VALUE"}
                        keyColName={"id"}
                        value={userType3SortOrderNo8Value}
                        options={userType3SortOrderNo8List}
                        onChange={this.onAutocompleteChange}
                        errorText={
                          formErrors["userType3SortOrderNo8ValueError"]
                            ? formErrors["userType3SortOrderNo8ValueError"]
                            : ""
                        }
                        isError={
                          formErrors["userType3SortOrderNo8ValueError"]
                            ? formErrors["userType3SortOrderNo8ValueError"]
                            : ""
                        }
                      />
                    </Grid>

                    <Grid
                      item
                      display="flex"
                      alignItems="flex-end"
                      gap={2}
                      sm={8}
                      xs={12}
                      md={8}
                      lg={8}
                    >
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Analysis"}
                        onClick={() => this.onSearchHandler(3, 8)}
                      />

                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Summary"}
                        onClick={() => this.onSummaryHandler(3, 8)}
                      />
                      {isShowCategoryWiseAnalysis == 1 && (
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Category Wise Analysis"}
                          onClick={() => this.onCategoryHandler(3, 8)}
                        />
                      )}
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Team Wise Analysis"}
                        onClick={() => this.onSearchHandlerForSalesTeam(3, 8)}
                      />
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Team Wise Summary"}
                        onClick={() =>
                          this.onSearchHandlerForTeamWiseSummary(3, 8)
                        }
                      />
                    </Grid>
                  </Grid>
                  <br />
                </>
              )}
              {userType4SortOrderNo1List.length != 0 && (
                <>
                  <Grid
                    sm={12}
                    xs={12}
                    md={12}
                    lg={12}
                    container
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Grid item sm={3.8} xs={12} md={3.8} lg={3.8}>
                      <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16, color: redColor }}
                        label={"*"}
                      />
                      <LabelCompo
                        className="text-black"
                        style={{
                          fontSize: 16,
                          color: titleColor,
                        }}
                        label={userType4SortOrderNo1Flag.name + " :"}
                      />{" "}
                      <AutoComplete
                        name={userType4SortOrderNo1Flag}
                        label={""}
                        placeHolder={"SELECT VALUE"}
                        keyColName={"id"}
                        value={userType4SortOrderNo1Value}
                        options={userType4SortOrderNo1List}
                        onChange={this.onAutocompleteChange}
                        errorText={
                          formErrors["userType4SortOrderNo1ValueError"]
                            ? formErrors["userType4SortOrderNo1ValueError"]
                            : ""
                        }
                        isError={
                          formErrors["userType4SortOrderNo1ValueError"]
                            ? formErrors["userType4SortOrderNo1ValueError"]
                            : ""
                        }
                      />
                    </Grid>

                    <Grid
                      item
                      display="flex"
                      alignItems="flex-end"
                      gap={2}
                      sm={8}
                      xs={12}
                      md={8}
                      lg={8}
                    >
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Analysis"}
                        onClick={() => this.onSearchHandler(4, 1)}
                      />

                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name={"Summary"}
                        onClick={() => this.onSummaryHandler(4, 1)}
                      />
                      {isShowCategoryWiseAnalysis == 1 && (
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Category Wise Analysis"}
                          onClick={() => this.onCategoryHandler(4, 1)}
                        />
                      )}
                    </Grid>
                  </Grid>
                  <br />
                </>
              )}
            </>
          ) : radioType == 1 ? (
            <>
              <Grid
                container
                spacing={3}
                alignItems="center"
                justifyContent="flex-start"
              >
                {isShowCategoryWiseAnalysis == 0 ? (
                  <>
                    <Grid item xs={12}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <LabelCompo
                              className="text-black"
                              style={{ fontSize: 16, color: redColor }}
                              label={"*"}
                            />
                            <LabelCompo
                              className="text-black"
                              style={{ fontSize: 16, color: titleColor }}
                              label={"Stock Holder Type"}
                            />
                          </div>
                          <AutoComplete
                            keyColName={"id"}
                            placeHolder="Select Stock Holder Type"
                            value={stockHolderType}
                            name={"stockHolderType"}
                            options={
                              stockStakeHolderTypeList?.stockStakeHolderType
                            }
                            errorText={formErrors["stockHolderTypeError"] || ""}
                            isError={formErrors["stockHolderTypeError"] || ""}
                            onChange={this.onAutocompleteChangeTypeWise}
                          />
                        </Grid>

                        {/* Sales Team */}
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <LabelCompo
                              className="text-black"
                              style={{ fontSize: 16, color: redColor }}
                              label={"*"}
                            />
                            <LabelCompo
                              className="text-black"
                              style={{ fontSize: 16, color: titleColor }}
                              label={"Sales Team"}
                            />
                          </div>
                          <AutoComplete
                            keyColName={"id"}
                            placeHolder="Select Sales Team"
                            value={salesTeam}
                            name={"salesTeam"}
                            options={salesExecutiveList?.salesExecutive}
                            errorText={formErrors["salesTeamError"] || ""}
                            isError={formErrors["salesTeamError"] || ""}
                            onChange={this.onAutocompleteChangeTypeWise}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* Buttons - Second Row */}
                    <Grid item xs={12}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: 16,
                        }}
                      >
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Analysis"}
                          onClick={() => this.onSearchHandlerTypeWise()}
                        />
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Summary"}
                          onClick={() => this.onSummaryHandlerTypeWise()}
                        />

                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Team Wise Analysis"}
                          onClick={() =>
                            this.onSearchHandlerTypeWiseForSalesTeam()
                          }
                        />

                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Team Wise Summary"}
                          onClick={() =>
                            this.onSearchHandlerTypeWiseForTeamWiseSummary()
                          }
                        />
                      </div>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={12}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <LabelCompo
                              className="text-black"
                              style={{ fontSize: 16, color: redColor }}
                              label={"*"}
                            />
                            <LabelCompo
                              className="text-black"
                              style={{ fontSize: 16, color: titleColor }}
                              label={"Stock Holder Type"}
                            />
                          </div>
                          <AutoComplete
                            keyColName={"id"}
                            placeHolder="Select Stock Holder Type"
                            value={stockHolderType}
                            name={"stockHolderType"}
                            options={
                              stockStakeHolderTypeList?.stockStakeHolderType
                            }
                            errorText={formErrors["stockHolderTypeError"] || ""}
                            isError={formErrors["stockHolderTypeError"] || ""}
                            onChange={this.onAutocompleteChangeTypeWise}
                          />
                        </Grid>

                        {/* Sales Team */}
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <LabelCompo
                              className="text-black"
                              style={{ fontSize: 16, color: redColor }}
                              label={"*"}
                            />
                            <LabelCompo
                              className="text-black"
                              style={{ fontSize: 16, color: titleColor }}
                              label={"Sales Team"}
                            />
                          </div>
                          <AutoComplete
                            keyColName={"id"}
                            placeHolder="Select Sales Team"
                            value={salesTeam}
                            name={"salesTeam"}
                            options={salesExecutiveList?.salesExecutive}
                            errorText={formErrors["salesTeamError"] || ""}
                            isError={formErrors["salesTeamError"] || ""}
                            onChange={this.onAutocompleteChangeTypeWise}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* Buttons - Second Row */}
                    <Grid item xs={12}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: 16,
                        }}
                      >
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Analysis"}
                          onClick={() => this.onSearchHandlerTypeWise()}
                        />
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Summary"}
                          onClick={() => this.onSummaryHandlerTypeWise()}
                        />

                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Category Wise Analysis"}
                          onClick={() => this.onCategoryHandlerTypeWise()}
                        />

                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Team Wise Analysis"}
                          onClick={() =>
                            this.onSearchHandlerTypeWiseForSalesTeam()
                          }
                        />

                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Team Wise Summary"}
                          onClick={() =>
                            this.onSearchHandlerTypeWiseForTeamWiseSummary()
                          }
                        />
                      </div>
                    </Grid>
                  </>
                )}
              </Grid>
            </>
          ) : (
            <Grid
              container
              spacing={3}
              alignItems="center"
              justifyContent="flex-start"
            >
              {isShowCategoryWiseAnalysis == 0 ? (
                <Grid item xs={12}>
                  <Grid container spacing={0} alignItems="center">
                    {/* Sales Team */}
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <LabelCompo
                          className="text-black"
                          style={{ fontSize: 16, color: redColor }}
                          label={"*"}
                        />
                        <LabelCompo
                          className="text-black"
                          style={{ fontSize: 16, color: titleColor }}
                          label={"Sales Team"}
                        />
                      </div>
                      <AutoComplete
                        keyColName={"id"}
                        placeHolder="Select Sales Team"
                        value={salesTeam}
                        name={"salesTeam"}
                        options={salesExecutiveList?.salesExecutiveBelowTeam}
                        errorText={formErrors["salesTeamError"] || ""}
                        isError={formErrors["salesTeamError"] || ""}
                        onChange={this.onAutocompleteChangeTypeWise}
                      />
                    </Grid>

                    {/* Buttons in the same row */}
                    <Grid item xs={12} sm={6} md={8} lg={8}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          gap: 16,
                          flexWrap: "wrap", // Allow wrapping on smaller screens
                          marginLeft: 16, // Move buttons closer to Sales Team
                          marginTop: 24, // Move buttons down for proper alignment with AutoComplete
                        }}
                      >
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Analysis"}
                          onClick={() => this.onSearchHandlerTypeWise()}
                        />
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Summary"}
                          onClick={() => this.onSummaryHandlerTypeWise()}
                        />
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Team Wise Analysis"}
                          onClick={() => this.onSearchHandlerTypeWiseForSalesTeam()}
                        />
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Team Wise Summary"}
                          onClick={() => this.onSearchHandlerTypeWiseForTeamWiseSummary()}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <Grid container spacing={0} alignItems="center">
                    {/* Sales Team */}
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <LabelCompo
                          className="text-black"
                          style={{ fontSize: 16, color: redColor }}
                          label={"*"}
                        />
                        <LabelCompo
                          className="text-black"
                          style={{ fontSize: 16, color: titleColor }}
                          label={"Sales Team"}
                        />
                      </div>
                      <AutoComplete
                        keyColName={"id"}
                        placeHolder="Select Sales Team"
                        value={salesTeam}
                        name={"salesTeam"}
                        options={salesExecutiveList?.salesExecutiveBelowTeam}
                        errorText={formErrors["salesTeamError"] || ""}
                        isError={formErrors["salesTeamError"] || ""}
                        onChange={this.onAutocompleteChangeTypeWise}
                      />
                    </Grid>

                    {/* Buttons in the same row */}
                    <Grid item xs={12} sm={6} md={8} lg={8}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          gap: 16,
                          flexWrap: "wrap", // Allow wrapping on smaller screens
                          marginLeft: 16, // Move buttons closer to Sales Team
                          marginTop: 24, // Move buttons down for proper alignment with AutoComplete
                        }}
                      >
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Analysis"}
                          onClick={() => this.onSearchHandlerTypeWise()}
                        />
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Summary"}
                          onClick={() => this.onSummaryHandlerTypeWise()}
                        />
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Category Wise Analysis"}
                          onClick={() => this.onCategoryHandlerTypeWise()}
                        />
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Team Wise Analysis"}
                          onClick={() => this.onSearchHandlerTypeWiseForSalesTeam()}
                        />
                        <ButtonCompo
                          size="medium"
                          type="submit"
                          variant="contained"
                          name={"Team Wise Summary"}
                          onClick={() => this.onSearchHandlerTypeWiseForTeamWiseSummary()}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          )}

          <br />

          {/* Analysis & Sales team wise data Table */}

          {rowList.length !== 0 && !summaryTableFlag && (
            <LandingScreenHeader
              screenTitle={""}
              showTable={true}
              showBackButton={false}
              showAddButton={false}
              showPdfDownload={false}
              showExcelDownload={true}
              showSearchBox={true}
              onSearch={this.onSearchForAnalysis}
              generateExcel={
                radioType == 0
                  ? this.generateExcelUserSummaryEmployeeWiseOnTable
                  : this.generateExcelForUserSummaryTypeWiseOnTable
              }
            />
          )}

          {rowList.length !== 0 && !summaryTableFlag && (
            <TableContainer
              component={Paper}
              style={{ maxHeight: 550, overflowY: "auto" }}
              aria-label="scrollable table"
            >
              <Table stickyHeader size="medium">
                <TableHead
                  style={{
                    backgroundColor: "#fff",
                  }}
                >
                  <TableRow>
                    <TableCell
                      color="#000"
                      align="center"
                      sx={{ width: "1%", color: "#000" }}
                      canSearch="true"
                    >
                      Sr.No
                    </TableCell>
                    <TableCell
                      color="#000"
                      align="center"
                      sx={{ width: "1%", color: "#000" }}
                      canSearch="true"
                    >
                      Employee Code
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ width: "9%", color: "#000" }}
                      canSearch="true"
                    >
                      Sales Team Name
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{ width: "7%", color: "#000" }}
                      canSearch="true"
                    >
                      Type
                    </TableCell>

                    {dateFlag == 1 && (
                      <>
                        <TableCell
                          align="center"
                          sx={{ width: "6%", color: "#000" }}
                          canSearch="true"
                        >
                          Check-In Time
                        </TableCell>

                        <TableCell
                          align="center"
                          sx={{ width: "6%", color: "#000" }}
                          canSearch="true"
                        >
                          Check-Out Time
                        </TableCell>

                        <TableCell
                          align="center"
                          sx={{ width: "5%", color: "#000" }}
                          canSearch="true"
                        >
                          First Call
                        </TableCell>

                        <TableCell
                          align="center"
                          sx={{ width: "5%", color: "#000" }}
                          canSearch="true"
                        >
                          Last Call
                        </TableCell>

                        <TableCell
                          align="center"
                          sx={{ width: "7%", color: "#000" }}
                          canSearch="true"
                        >
                          Total Call Time
                        </TableCell>

                        <TableCell
                          align="center"
                          sx={{ width: "3%", color: "#000" }}
                          canSearch="true"
                        >
                          Working Hours
                        </TableCell>
                      </>
                    )}

                    <TableCell
                      align="center"
                      sx={{ width: "3%", color: "#000" }}
                      canSearch="true"
                    >
                      Beat Count
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{ width: "3%", color: "#000" }}
                      canSearch="true"
                    >
                      Total Outlet
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{ width: "3%", color: "#000" }}
                      canSearch="true"
                    >
                      Productive Call
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{ width: "3%", color: "#000" }}
                      canSearch="true"
                    >
                      Remote Order
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{ width: "3%", color: "#000" }}
                      canSearch="true"
                    >
                      Zero Order
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{ width: "3%", color: "#000" }}
                      canSearch="true"
                    >
                      Total Order Call
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{ width: "3%", color: "#000" }}
                      canSearch="true"
                    >
                      Total Order Amount
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.getFilteredTableData(rowList).map(
                    (salesTeamObject, index) => {
                      return (
                        <TableRow>
                          <TableCell align="center" canSearch="true">
                            {index + 1}
                          </TableCell>
                          <TableCell align="center" canSearch="true">
                            {salesTeamObject.employeeCode}
                          </TableCell>
                          <TableCell width="2%" canSearch="true">
                            <Link
                              color={cyanBlue}
                              component={RouterLink}
                              to={
                                localStorage.getItem(
                                  "showRealTimeTracking"
                                ) &&
                                  localStorage.getItem(
                                    "showRealTimeTracking"
                                  ) == 1
                                  ? "/gmap-with-functionality/" +
                                  salesTeamObject.id +
                                  "/" +
                                  salesTeamObject.userTypeId
                                  : "/sales/" +
                                  salesTeamObject.id +
                                  "/" +
                                  salesTeamObject.userTypeId
                              }
                            >
                              {salesTeamObject.name}
                            </Link>
                          </TableCell>

                          <TableCell align="left" canSearch="true">
                            {salesTeamObject.stockStakeHolderTypeName}
                          </TableCell>

                          {dateFlag == 1 && (
                            <>
                              <TableCell align="center" canSearch="true">
                                {salesTeamObject.checkInTime}
                              </TableCell>

                              <TableCell align="center" canSearch="true">
                                {salesTeamObject.checkOutTime}
                              </TableCell>

                              <TableCell align="center" canSearch="true">
                                {salesTeamObject.firstCallTime}
                              </TableCell>

                              <TableCell align="center" canSearch="true">
                                {salesTeamObject.lastCallTime}
                              </TableCell>

                              <TableCell align="center" canSearch="true">
                                {salesTeamObject.totalRetailCallTime}
                              </TableCell>

                              <TableCell align="center" canSearch="true">
                                {salesTeamObject.workingHrs}
                              </TableCell>
                            </>
                          )}

                          <TableCell width="2%" align="right" canSearch="true">
                            <div
                              onClick={(e) =>
                                this.salesTeamHandler(e, salesTeamObject.id)
                              }
                              style={{
                                color: cyanBlue,
                                cursor: "pointer",
                              }}
                            >
                              {salesTeamObject.beatCounts}
                            </div>
                          </TableCell>

                          <TableCell align="right" canSearch="true">
                            {salesTeamObject.totalOutlet}
                          </TableCell>

                          <TableCell align="right" canSearch="true">
                            {salesTeamObject.productiveOrderCall}
                          </TableCell>

                          <TableCell align="right" canSearch="true">
                            {salesTeamObject.remoteOrderCall}
                          </TableCell>

                          <TableCell align="right" canSearch="true">
                            {salesTeamObject.zeroOrdeCall}
                          </TableCell>

                          <TableCell align="right" canSearch="true">
                            {salesTeamObject.totalOrderCall}
                          </TableCell>

                          <TableCell align="right" canSearch="true">
                            {(+salesTeamObject.totalOrderAmt).toFixed(2)}
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          <br />

          {/* Sales Team Summary Table */}

          {managerList?.salesTeamWorkingSummary.length !== 0 &&
            summaryTableFlag && (
              <LandingScreenHeader
                screenTitle={""}
                showTable={true}
                showBackButton={false}
                showAddButton={false}
                showPdfDownload={false}
                showExcelDownload={true}
                showSearchBox={true}
                onSearch={this.onSearchForSummary}
                generateExcel={
                  radioType == 0
                    ? this.generateExcelForUserWorkSummaryEmployeeWiseOnTable
                    : this.generateExcelForUserWorkSummaryTypeWiseOnTable
                }
              />
            )}
          {managerList?.salesTeamWorkingSummary.length !== 0 &&
            summaryTableFlag && (
              <div
                style={{
                  maxHeight: "550px",
                  overflowX: "auto",
                  maxWidth: "100%",
                  borderRadius: "10px",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                  background: "#fff",
                  border: "1px solid #e0e0e0",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "separate",
                    borderSpacing: 0,
                    fontFamily: "Segoe UI, Arial, sans-serif",
                    fontSize: "15px",
                    background: "#fff",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        position: "sticky",
                        top: 0,
                        background: "#f7fafc",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.03)",
                        zIndex: 2,
                      }}
                    >
                      <th style={{ ...thStyle, width: "65px" }}>Sr. No.</th>
                      <th style={{ ...thStyle, width: "65px" }}>Date</th>
                      <th style={{ ...thStyle, width: "65px" }}>
                        Employee Code
                      </th>
                      <th style={{ ...thStyle, width: "95px" }}>Sales Team</th>
                      <th style={{ ...thStyle, width: "95px" }}>Type</th>
                      <th style={{ ...thStyle, width: "85px" }}>
                        Working Type
                      </th>
                      <th style={{ ...thStyle, width: "85px" }}>Task Name</th>
                      <th style={{ ...thStyle, width: "80px" }}>From Time</th>
                      <th style={{ ...thStyle, width: "80px" }}>To Time</th>
                      <th style={{ ...thStyle, width: "150px" }}>Reason</th>
                      <th style={{ ...thStyle, width: "80px" }}>Outlet Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.getFilteredTableDataForSummaryTable(
                      managerList?.salesTeamWorkingSummary
                    ).map((row, index) => (
                      <tr
                        key={row.id}
                        style={{
                          background: index % 2 === 0 ? "#fafbfc" : "#fff",
                          transition: "background 0.2s",
                          borderBottom: "1px solid #eaeaea",
                          cursor: "pointer",
                          ":hover": { background: "#f1f5fa" },
                        }}
                      >
                        <td style={tdCenterStyle}>{index + 1}</td>
                        <td style={tdCenterStyle}>{row.date}</td>
                        <td style={tdCenterStyle}>{row.employeeCode}</td>
                        <td style={tdStyle}>
                          <Link
                            color={cyanBlue}
                            component={RouterLink}
                            to={
                              localStorage.getItem(
                                "showRealTimeTracking"
                              ) &&
                                localStorage.getItem(
                                  "showRealTimeTracking"
                                ) == 1
                                ? "/gmap-with-functionality/" +
                                row.salesTeamId +
                                "/" +
                                row.userTypeId
                                : "/sales/" +
                                row.salesTeamId +
                                "/" +
                                row.userTypeId
                            }
                          >
                            {row.salesTeamName}
                          </Link>
                        </td>
                        <td style={tdStyle}>{row.stockStakeHolderTypeName}</td>
                        <td style={tdStyle}>{row.workingTypeName}</td>
                        <td style={tdStyle}>{row.otherTaskName}</td>
                        <td style={tdCenterStyle}>{row.fromTime}</td>
                        <td style={tdCenterStyle}>{row.toTime}</td>
                        <td style={tdStyle}>{row.reason}</td>
                        <td style={tdStyle}>{row.firmName}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

          {/* Category Wise Analysis Table */}

          {(dataResponseForSubCat.categories?.length > 0 ||
            dataResponseForSubCat.subCategories?.length > 0 ||
            dataResponseForSubCat.salesTeamListWithDate?.length > 0 ||
            dataResponseForSubCat.salesTeamWithSubCategoryValues?.length > 0) &&
            !summaryTableFlag && (
              <SubCategoryWiseForUserSummary
                subCatList={catsubCatMatrixData}
                subCatListWithValue={matrixDataListForSubCat}
                fromDate={fromDate}
                toDate={toDate}
                salesTeam={salesTeam}
                generateExcelByProps={this.generateExcelByProps}
              />
            )}

          {beatPopUpFlag && (
            <BeatPopUp
              open={beatPopUpFlag}
              handleCloses={this.handleClosesSalesTeam}
              columns={[
                {
                  title: "Sr. No.",
                  name: "index",
                  positionCenter: false,
                  showInscreen: true,
                  alignCenter: "center",
                  canSearch: true,
                },
                {
                  title: "Beat",
                  name: "beatName",
                  positionCenter: false,
                  showInscreen: true,
                  alignCenter: "left",
                  canSearch: true,
                },
              ]}
              rows={beatList?.beatFromSalesTeamId}
            />
          )}
          <br />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  beatList: state.beat,
  managerList: state.manager,
  stockStakeHolderTypeList: state.stockStakeHolderType,
  salesExecutiveList: state.salesExecutive,
  salesTeamCategoryWiseDataList: state.salesTeamCategoryWiseData,
});
const mapDispatchToProps = {
  getTopOrderSalesTeam,
  getSalesTeamUserSummary,
  getBelowSalesTeamByReportingId,
  getSelectedBeatCountFromSalesTeamIdAndDate,
  showLoador,
  showNotification,
  getStockStakeHolderType,
  getSalesExecutive,
  getSalesTeamWorkingSummary,
  getUnderSalesTeamWorkingSummary,
  setSalesTeamWorkingSummary,
  getSubCategoryWiseReportBySalesTeam,
  getSalesTeamUserSummaryTeamWise,
  setSalesTeamUserSummaryTeamWise,
  getBelowSalesTeamList,
};
export default connect(mapStateToProps, mapDispatchToProps)(UserSummaryNew);

const thStyle = {
  padding: "12px 8px",
  background: " #03a9f4",
  color: "rgb(255, 255, 255)",
  fontWeight: 530,
  borderBottom: "2px solid #e0e0e0",
  textAlign: "center",
  fontSize: "15px",
  letterSpacing: "0.02em",
  borderRight: "1px solid #e0e0e0", // Add this line!
};

const tdStyle = {
  padding: "10px 8px",
  borderBottom: "1px solid #eaeaea",
  textAlign: "left",
  fontSize: "15px",
  verticalAlign: "middle",
  borderRight: "1px solid #e0e0e0", // Add this line!
};

const tdCenterStyle = {
  ...tdStyle,
  textAlign: "center",
};
